// src/pages/Settings/Settings.jsx

import React, { useState, useEffect, useCallback } from 'react';
import { useOutletContext } from 'react-router-dom';
import { doc, getDoc, setDoc, collection, addDoc, onSnapshot, query, where, updateDoc, getDocs, orderBy, limit } from 'firebase/firestore';
import { db, firebaseConfig } from '../../firebase';
import { useAuth } from '../../context/AuthContext';
import { initializeApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { functions } from '../../firebase'; // DÜZELTME: functions eklendi
import { httpsCallable } from "firebase/functions"; // DÜZELTME: httpsCallable eklendi
import * as XLSX from 'xlsx';
import ImageUpload from '../../components/ImageUpload';
import { useNavigate } from 'react-router-dom';
import CargoIntegrationSettings from '../../components/settings/CargoIntegrationSettings';
import { GEMINI_MODELS, DEFAULT_GEMINI_MODEL } from '../../gemini';

// --- STYLES ---
const styles = {
    container: {
        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        background: 'transparent'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '32px'
    },
    headerLeft: {
        display: 'flex',
        flexDirection: 'column'
    },
    title: {
        fontSize: '32px',
        fontWeight: '700',
        color: '#0f172a',
        margin: 0,
        letterSpacing: '-0.5px'
    },
    subtitle: {
        fontSize: '16px',
        color: '#64748b',
        marginTop: '4px'
    },
    tabs: {
        display: 'flex',
        flexWrap: 'wrap',
        borderBottom: '1px solid #e2e8f0',
        marginBottom: '32px',
        background: 'white',
        borderRadius: '12px 12px 0 0',
        padding: '0 24px'
    },
    tab: {
        padding: '16px 24px',
        cursor: 'pointer',
        border: 'none',
        background: 'none',
        fontSize: '14px',
        fontWeight: '500',
        color: '#64748b',
        borderBottom: '2px solid transparent',
        transition: 'all 0.2s'
    },
    activeTab: {
        borderBottom: '2px solid #06C167',
        color: '#06C167',
        fontWeight: '600'
    },
    content: {
        background: 'white',
        padding: '32px',
        borderRadius: '16px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        border: '1px solid #e2e8f0'
    },
    formContainer: { maxWidth: '600px' },
    formGroup: { marginBottom: '20px' },
    label: {
        display: 'block',
        marginBottom: '8px',
        fontWeight: '600',
        color: '#374151',
        fontSize: '14px'
    },
    input: {
        width: '100%',
        padding: '12px 16px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        boxSizing: 'border-box',
        fontSize: '14px',
        outline: 'none',
        transition: 'border-color 0.2s'
    },
    button: {
        padding: '12px 24px',
        border: 'none',
        background: 'linear-gradient(135deg, #06C167, #8b5cf6)',
        color: 'white',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '600',
        boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
        transition: 'all 0.2s ease-in-out'
    },
    message: {
        marginTop: '16px',
        padding: '12px 16px',
        borderRadius: '8px',
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: '500'
    },
    successMessage: {
        background: '#dcfce7',
        color: '#166534',
        border: '1px solid #bbf7d0'
    },
    errorMessage: {
        background: '#fef2f2',
        color: '#dc2626',
        border: '1px solid #fecaca'
    },
    listContainer: { marginTop: '24px' },
    listItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 20px',
        borderBottom: '1px solid #f1f5f9',
        transition: 'background 0.2s'
    },
    permissionGroup: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        gap: '16px',
        marginBottom: '20px'
    },
    permissionCheckbox: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '12px',
        background: '#f8fafc',
        borderRadius: '8px',
        border: '1px solid #e2e8f0'
    },
    invitationLinkBox: {
        background: '#f8fafc',
        border: '1px dashed #cbd5e1',
        padding: '16px',
        marginTop: '16px',
        wordBreak: 'break-all',
        borderRadius: '8px',
        fontSize: '13px',
        color: '#475569'
    },
    itemEmail: { fontWeight: '600', color: '#374151' },
    itemStatus: {
        fontStyle: 'italic',
        color: '#64748b',
        fontSize: '13px'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 100
    },
    modalContent: {
        background: 'white',
        padding: '32px',
        borderRadius: '16px',
        width: '90%',
        maxWidth: '500px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
        maxHeight: '80vh',
        overflowY: 'auto'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px'
    },
    modalActions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px',
        marginTop: '24px'
    },
    permissionGroup: {
        maxHeight: '60vh',
        overflowY: 'auto',
        paddingRight: '10px'
    },
    resultsBox: {
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        padding: '16px',
        marginTop: '20px',
        whiteSpace: 'pre-wrap',
        fontFamily: 'monospace',
        maxHeight: '300px',
        overflowY: 'auto',
        fontSize: '13px'
    },
    deleteButton: {
        background: 'none',
        border: 'none',
        color: '#dc2626',
        cursor: 'pointer',
        fontSize: '18px',
        padding: '8px',
        borderRadius: '6px',
        transition: 'background 0.2s'
    },
    sectionTitle: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#0f172a',
        marginBottom: '16px'
    }
};

// --- BİLEŞENLER ---

function CompanyInfoSection({ userData, showMessage }) {
    const [companyInfo, setCompanyInfo] = useState({ 
        companyName: '', 
        taxOffice: '', 
        taxNumber: '', 
        address: '', 
        phone: '', 
        customerCode: '',
        logoUrl: '' 
    });

    const [loading, setLoading] = useState(true);

    const fetchCompanyInfo = useCallback(async () => {
        if (!userData?.companyId) return;
        const companyDocRef = doc(db, 'companies', userData.companyId);
        const docSnap = await getDoc(companyDocRef);
        if (docSnap.exists()) setCompanyInfo(prev => ({ ...prev, ...docSnap.data() }));
        setLoading(false);
    }, [userData]);

    useEffect(() => { fetchCompanyInfo(); }, [fetchCompanyInfo]);

    const handleChange = (e) => setCompanyInfo(prev => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSave = async (e) => {
        e.preventDefault();
        if (!userData?.companyId) return;
        const companyDocRef = doc(db, 'companies', userData.companyId);
        try {
            await setDoc(companyDocRef, companyInfo, { merge: true });
            showMessage('Firma bilgileri başarıyla güncellendi!');
        } catch (error) {
            showMessage('Bilgiler kaydedilirken bir hata oluştu.', 'error');
        }
    };

    if (loading) return <div style={styles.loadingState}>Yükleniyor...</div>;

    return (
        <div style={styles.formContainer}>
            <h2 style={styles.sectionTitle}>Firma Bilgileri</h2>
            <form onSubmit={handleSave}>
                <div style={styles.formGroup}><label style={styles.label}>Firma Adı</label><input style={styles.input} type="text" name="companyName" value={companyInfo.companyName} onChange={handleChange} /></div>
                <div style={styles.formGroup}><label style={styles.label}>Vergi Dairesi</label><input style={styles.input} type="text" name="taxOffice" value={companyInfo.taxOffice} onChange={handleChange} /></div>
                <div style={styles.formGroup}><label style={styles.label}>Vergi Numarası</label><input style={styles.input} type="text" name="taxNumber" value={companyInfo.taxNumber} onChange={handleChange} /></div>
                <div style={styles.formGroup}><label style={styles.label}>Adres</label><input style={styles.input} type="text" name="address" value={companyInfo.address} onChange={handleChange} /></div>
                <div style={styles.formGroup}><label style={styles.label}>Telefon</label><input style={styles.input} type="text" name="phone" value={companyInfo.phone} onChange={handleChange} /></div>
                
                <div style={styles.formGroup}>
                    <label style={styles.label}>Şirket Logosu</label>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '20px' }}>
                        {companyInfo.logoUrl && (
                            <div style={{ position: 'relative' }}>
                                <img 
                                    src={companyInfo.logoUrl} 
                                    alt="Logo" 
                                    style={{ width: '120px', height: '120px', objectFit: 'contain', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '10px' }} 
                                />
                                <button
                                    type="button"
                                    onClick={() => setCompanyInfo(prev => ({ ...prev, logoUrl: '' }))}
                                    style={{ position: 'absolute', top: '-10px', right: '-10px', background: '#ef4444', color: 'white', border: 'none', borderRadius: '50%', width: '24px', height: '24px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}
                                >
                                    &times;
                                </button>
                            </div>
                        )}
                        <div style={{ flex: 1 }}>
                            <ImageUpload 
                                onUploadSuccess={(url) => setCompanyInfo(prev => ({ ...prev, logoUrl: url }))}
                                folder={`companies/${userData.companyId}/logo`}
                            />
                            <p style={{ fontSize: '12px', color: '#64748b', marginTop: '8px' }}>
                                Önerilen boyutlar: 400x400px. Şeffaf (PNG) veya beyaz arka planlı görseller PDF çıktılarında daha iyi görünür.
                            </p>
                        </div>
                    </div>
                </div>

                <div style={styles.formGroup}><label style={styles.label}>Sipariş Gönderici E-posta</label><input style={styles.input} type="email" name="senderEmail" value={companyInfo.senderEmail || ''} onChange={handleChange} placeholder="örnek@sirketiniz.com" /><small style={{ color: '#64748b', fontSize: '12px' }}>Bu e-posta adresinin SendGrid hesabınızda doğrulanmış olması gerekir.</small></div>

                <div style={styles.formGroup}><label style={styles.label}>Gönderici Müşteri Kodu</label><input style={styles.input} type="text" name="customerCode" value={companyInfo.customerCode || ''} onChange={handleChange} placeholder="Müşteri kodunuzu girin" /></div>

                {/* Display Company ID */}
                <div style={styles.formGroup}>
                    <label style={styles.label}>Firma ID</label>
                    <input
                        style={{ ...styles.input, backgroundColor: '#f8f9fa', cursor: 'not-allowed' }}
                        type="text"
                        value={userData?.companyId || ''}
                        readOnly
                    />
                    <small style={{ color: '#6c757d', display: 'block', marginTop: '5px' }}>
                        Bu ID sistem tarafından otomatik atanır ve değiştirilemez.
                    </small>
                </div>

                <button type="submit" style={styles.button} disabled={userData.role === 'personel'}>
                    {userData.role === 'personel' ? 'Yetkiniz Yok' : 'Bilgileri Kaydet'}
                </button>
            </form>
        </div>
    );
}

function EditPersonnelModal({ personnel, onClose, onSave, permissionLabels }) {
    // Ensure all permissions are properly initialized, including viewPrices
    const initialPermissions = {
        dashboard: true,
        raporlar: false,
        kasa: false,
        musteriler: false,
        tedarikciler: false,
        stok: false,
        alisFaturalari: false,
        satisFaturalari: false,
        siparisler: false,
        istekSiparisler: false,
        ayarlar: false,
        viewPrices: false,
        ...(personnel.permissions || {})
    };

    const [permissions, setPermissions] = useState(initialPermissions);

    const handlePermissionChange = (e) => {
        const { name, checked } = e.target;
        setPermissions(prev => ({ ...prev, [name]: checked }));
    };

    const handleSave = () => {
        onSave(permissions);
    };

    return (
        <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
                <div style={styles.modalHeader}>
                    <h3>Yetki Düzenle: {personnel.email}</h3>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>&times;</button>
                </div>
                <div style={styles.permissionGroup}>
                    {Object.keys(permissionLabels).map(key => {
                        // Ana menü yetkileri için başlık göster
                        const isMainPermission = !key.includes('view') && !key.includes('create') && !key.includes('edit') && !key.includes('delete') && !key.includes('add');
                        const isSubPermission = !isMainPermission;

                        return (
                            <div key={key}>
                                {isMainPermission && (
                                    <h4 style={{ marginTop: '15px', marginBottom: '5px', fontSize: '16px', color: '#333' }}>
                                        {permissionLabels[key]}
                                    </h4>
                                )}
                                <label
                                    style={{
                                        ...styles.permissionCheckbox,
                                        marginLeft: isSubPermission ? '20px' : '0',
                                        display: 'block',
                                        marginBottom: '5px'
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        name={key}
                                        checked={permissions[key] || false}
                                        onChange={handlePermissionChange}
                                        disabled={key === 'dashboard'}
                                    />
                                    {permissionLabels[key] || key}
                                </label>
                            </div>
                        );
                    })}
                </div>
                <div style={styles.modalActions}>
                    <button onClick={onClose} style={{ ...styles.button, background: '#6c757d' }}>İptal</button>
                    <button onClick={handleSave} style={{ ...styles.button, background: '#28a745' }}>Kaydet</button>
                </div>
            </div>
        </div>
    );
}

function PersonnelManagementSection({ userData, showMessage }) {
    const { refreshPermissions } = useAuth();
    const [email, setEmail] = useState('');
    const [permissions, setPermissions] = useState({
        // Ana menü yetkileri
        dashboard: true,
        raporlar: false,
        kasa: false,
        musteriler: false,
        tedarikciler: false,
        stok: false,
        alisFaturalari: false,
        satisFaturalari: false,
        siparisler: false,
        istekSiparisler: false,
        ayarlar: false,
        viewPrices: false,

        // Detaylı yetkiler - Müşteriler
        viewCustomers: false,
        createCustomers: false,
        editCustomers: false,
        deleteCustomers: false,

        // Detaylı yetkiler - Siparişler
        viewOrders: false,
        createOrders: false,
        editOrders: false,
        deleteOrders: false,

        // Detaylı yetkiler - Stok
        viewStock: false,
        addStock: false,
        editStock: false,
        deleteStock: false,

        // Detaylı yetkiler - Kasa & Banka
        viewCashBank: false,
        addCashBank: false,
        editCashBank: false,

        // Detaylı yetkiler - Faturalar
        viewInvoices: false,
        createInvoices: false,
        editInvoices: false,
        deleteInvoices: false
    });
    const [personnelList, setPersonnelList] = useState([]);
    const [invitations, setInvitations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [invitationLink, setInvitationLink] = useState('');
    const [editingPersonnel, setEditingPersonnel] = useState(null);
    const [companyInfo, setCompanyInfo] = useState({ companyName: '' });

    const defaultPermissions = {
        dashboard: true,
        musteriler: false,
        tedarikciler: false,
        stok: false,
        stokGirisi: false,
        kasa: false,
        faturalar: false,
        alisFaturalari: false,
        raporlar: false,
        siparisler: false,
        istekSiparisler: false,
        ayarlar: false,
        viewPrices: false,

        // Detaylı yetkiler - Müşteriler
        viewCustomers: false,
        createCustomers: false,
        editCustomers: false,
        deleteCustomers: false,

        // Detaylı yetkiler - Siparişler
        viewOrders: false,
        createOrders: false,
        editOrders: false,
        deleteOrders: false,

        // Detaylı yetkiler - Stok
        viewStock: false,
        addStock: false,
        editStock: false,
        deleteStock: false,

        // Detaylı yetkiler - Kasa & Banka
        viewCashBank: false,
        addCashBank: false,
        editCashBank: false,

        // Detaylı yetkiler - Faturalar
        viewInvoices: false,
        createInvoices: false,
        editInvoices: false,
        deleteInvoices: false
    };

    const permissionLabels = {
        dashboard: 'Dashboard',
        musteriler: 'Müşteriler',
        tedarikciler: 'Tedarikçiler',
        stok: 'Stok',
        stokGirisi: 'Stok Girişi',
        kasa: 'Kasa & Banka',
        faturalar: 'Satış Faturaları',
        alisFaturalari: 'Alış Faturaları',
        raporlar: 'Raporlar',
        siparisler: 'Siparişler',
        istekSiparisler: 'İstek Siparişler',
        ayarlar: 'Ayarlar',
        viewPrices: 'Fiyatları Görme',

        // Detaylı yetkiler - Müşteriler
        viewCustomers: 'Müşterileri Görüntüle',
        createCustomers: 'Müşteri Oluştur',
        editCustomers: 'Müşteri Düzenle',
        deleteCustomers: 'Müşteri Sil',

        // Detaylı yetkiler - Siparişler
        viewOrders: 'Siparişleri Görüntüle',
        createOrders: 'Sipariş Oluştur',
        editOrders: 'Sipariş Düzenle',
        deleteOrders: 'Sipariş Sil',

        // Detaylı yetkiler - Stok
        viewStock: 'Stok Görüntüle',
        addStock: 'Stok Ekle',
        editStock: 'Stok Düzenle',
        deleteStock: 'Stok Sil',

        // Detaylı yetkiler - Kasa & Banka
        viewCashBank: 'Kasa & Banka Görüntüle',
        addCashBank: 'Kasa & Banka İşlemi Ekle',
        editCashBank: 'Kasa & Banka İşlemi Düzenle',

        // Detaylı yetkiler - Faturalar
        viewInvoices: 'Faturaları Görüntüle',
        createInvoices: 'Fatura Oluştur',
        editInvoices: 'Fatura Düzenle',
        deleteInvoices: 'Fatura Sil'
    };



    // Fetch company information
    useEffect(() => {
        if (!userData?.companyId) return;

        const fetchCompanyInfo = async () => {
            try {
                const companyDocRef = doc(db, 'companies', userData.companyId);
                const docSnap = await getDoc(companyDocRef);
                if (docSnap.exists()) {
                    setCompanyInfo(docSnap.data());
                }
            } catch (error) {
                console.error("Şirket bilgileri alınırken hata:", error);
            }
        };

        fetchCompanyInfo();
    }, [userData?.companyId]);

    useEffect(() => {
        if (!userData?.companyId) return;
        const personnelColRef = collection(db, 'companies', userData.companyId, 'personnel');
        const invitationsColRef = collection(db, 'companies', userData.companyId, 'invitations');

        const unsubPersonnel = onSnapshot(query(personnelColRef), snap => {
            setPersonnelList(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
        const unsubInvitations = onSnapshot(query(invitationsColRef, where("status", "==", "pending")), snap => {
            setInvitations(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });

        setLoading(false);
        return () => { unsubPersonnel(); unsubInvitations(); };
    }, [userData]);

    const handlePermissionChange = (e) => setPermissions(prev => ({ ...prev, [e.target.name]: e.target.checked }));

    const handleCreateInvitation = async (e) => {
        e.preventDefault();
        if (!userData?.companyId || !email.includes('@')) {
            showMessage('Lütfen geçerli bir e-posta adresi girin.', 'error');
            return;
        }
        setInvitationLink('');

        try {
            const invitationsColRef = collection(db, 'companies', userData.companyId, 'invitations');
            const newInvite = await addDoc(invitationsColRef, {
                email: email,
                permissions: permissions,
                status: 'pending',
                companyId: userData.companyId,
                createdAt: new Date()
            });

            const link = `${window.location.origin}/register-personnel/${userData.companyId}/${newInvite.id}`;
            setInvitationLink(link);
            showMessage('Davetiye linki başarıyla oluşturuldu! Linki personele iletin.');
            setEmail('');
        } catch (error) {
            showMessage("Davetiye oluşturulurken bir hata oluştu.", "error");
        }
    };

    // Yeni fonksiyon: Davet e-postası gönderme
    const handleSendInvitationEmail = async (emailAddress, invitationLink) => {
        try {
            const sendEmailFunction = httpsCallable(functions, 'sendPersonnelInvitationEmail');
            await sendEmailFunction({
                email: emailAddress,
                invitationLink: invitationLink,
                companyName: companyInfo.companyName || 'Şirketiniz'
            });
            showMessage('Davet e-postası başarıyla gönderildi!', 'success');
        } catch (error) {
            console.error("E-posta gönderme hatası:", error);
            showMessage("E-posta gönderilirken bir hata oluştu: " + error.message, "error");
        }
    };

    const handleUpdatePermissions = async (personnelId, newPermissions) => {
        const personnelRef = doc(db, 'companies', userData.companyId, 'personnel', personnelId);
        try {
            await updateDoc(personnelRef, { permissions: newPermissions });
            // Trigger a refresh of permissions in the AuthContext
            refreshPermissions();
            showMessage('Personel yetkileri başarıyla güncellendi!');
        } catch (error) {
            showMessage('Yetkiler güncellenirken bir hata oluştu.', 'error');
            console.error(error);
        }
    };

    return (
        <div style={styles.formContainer}>
            <h2>Yeni Personel Davet Et</h2>
            <form onSubmit={handleCreateInvitation}>
                <div style={styles.formGroup}><label style={styles.label}>Personel E-posta Adresi</label><input style={styles.input} type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="personel@sirket.com" required /></div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>Yetkiler</label>
                    <div style={styles.permissionGroup}>
                        {Object.keys(permissionLabels).map(key => (
                            <label key={key} style={styles.permissionCheckbox}>
                                <input type="checkbox" name={key} checked={permissions[key] || false} onChange={handlePermissionChange} disabled={key === 'dashboard'} />
                                {permissionLabels[key]}
                            </label>
                        ))}
                    </div>
                </div>
                <button type="submit" style={styles.button}>Davetiye Linki Oluştur</button>
            </form>

            {invitationLink && (
                <div style={{ ...styles.invitationLinkBox, position: 'relative' }}>
                    <b>Oluşturulan Davet Linki:</b><br />
                    {invitationLink}
                    <div style={{ marginTop: '10px' }}>
                        <button
                            onClick={() => handleSendInvitationEmail(email, invitationLink)}
                            style={{ ...styles.button, background: '#28a745', marginRight: '10px' }}
                        >
                            E-posta ile Gönder
                        </button>
                        <button
                            onClick={() => navigator.clipboard.writeText(invitationLink)}
                            style={{ ...styles.button, background: '#17a2b8' }}
                        >
                            Linki Kopyala
                        </button>
                    </div>
                </div>
            )}

            <div style={styles.listContainer}>
                <h2 style={{ marginTop: '40px' }}>Bekleyen Davetler</h2>
                {loading ? <p>Yükleniyor...</p> : invitations.length > 0 ? (
                    invitations.map(p => (
                        <div key={p.id} style={{ ...styles.listItem, flexDirection: 'column', alignItems: 'flex-start' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '8px' }}>
                                <span style={styles.itemEmail}>{p.email}</span>
                                <span style={styles.itemStatus}>Davet Gönderildi</span>
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button
                                    onClick={() => {
                                        const link = `${window.location.origin}/register-personnel/${userData.companyId}/${p.id}`;
                                        handleSendInvitationEmail(p.email, link);
                                    }}
                                    style={{ ...styles.button, padding: '5px 10px', fontSize: '12px', background: '#28a745' }}
                                >
                                    Tekrar Gönder
                                </button>
                                <button
                                    onClick={() => {
                                        const link = `${window.location.origin}/register-personnel/${userData.companyId}/${p.id}`;
                                        navigator.clipboard.writeText(link);
                                        showMessage('Link kopyalandı!', 'success');
                                    }}
                                    style={{ ...styles.button, padding: '5px 10px', fontSize: '12px', background: '#17a2b8' }}
                                >
                                    Linki Kopyala
                                </button>
                            </div>
                        </div>
                    ))
                ) : <p>Bekleyen davetiye bulunmuyor.</p>}
            </div>

            <div style={styles.listContainer}>
                <h2 style={{ marginTop: '40px' }}>Aktif Personeller</h2>
                {loading ? <p>Yükleniyor...</p> : personnelList.map(p => (
                    <div key={p.id} style={styles.listItem}>
                        <span style={styles.itemEmail}>{p.email}</span>
                        <button onClick={() => setEditingPersonnel(p)} style={{ ...styles.button, padding: '5px 10px', fontSize: '14px' }}>Düzenle</button>
                    </div>
                ))}
            </div>

            {editingPersonnel && (
                <EditPersonnelModal
                    personnel={editingPersonnel}
                    onClose={() => setEditingPersonnel(null)}
                    onSave={(newPermissions) => {
                        handleUpdatePermissions(editingPersonnel.id, newPermissions);
                        setEditingPersonnel(null);
                    }}
                    permissionLabels={permissionLabels}
                />
            )}
        </div>
    );
}



function ProductGroupsSection({ userData, showMessage, canViewSensitiveData }) {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [newGroup, setNewGroup] = useState({ name: '', defaultPurchasePrice: { amount: 0, currency: 'TRY' } });
    const [editingGroup, setEditingGroup] = useState(null);

    useEffect(() => {
        if (!userData?.companyId) return;
        const q = query(collection(db, 'companies', userData.companyId, 'productGroups'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setGroups(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setLoading(false);
        });
        return () => unsubscribe();
    }, [userData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'priceAmount') {
            setNewGroup(prev => ({ ...prev, defaultPurchasePrice: { ...prev.defaultPurchasePrice, amount: value } }));
        } else if (name === 'priceCurrency') {
            setNewGroup(prev => ({ ...prev, defaultPurchasePrice: { ...prev.defaultPurchasePrice, currency: value } }));
        } else {
            setNewGroup(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        if (name === 'priceAmount') {
            setEditingGroup(prev => ({ ...prev, defaultPurchasePrice: { ...prev.defaultPurchasePrice, amount: value } }));
        } else if (name === 'priceCurrency') {
            setEditingGroup(prev => ({ ...prev, defaultPurchasePrice: { ...prev.defaultPurchasePrice, currency: value } }));
        } else {
            setEditingGroup(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleAddGroup = async (e) => {
        e.preventDefault();
        if (!newGroup.name) {
            showMessage('Lütfen grup adını girin.', 'error');
            return;
        }
        try {
            await addDoc(collection(db, 'companies', userData.companyId, 'productGroups'), {
                name: newGroup.name,
                defaultPurchasePrice: {
                    amount: Number(newGroup.defaultPurchasePrice.amount) || 0,
                    currency: newGroup.defaultPurchasePrice.currency
                }
            });
            setNewGroup({ name: '', defaultPurchasePrice: { amount: 0, currency: 'TRY' } });
            showMessage('Ürün grubu başarıyla eklendi!');
        } catch (error) {
            showMessage('Grup eklenirken bir hata oluştu.', 'error');
        }
    };

    const handleSaveEdit = async () => {
        const groupRef = doc(db, 'companies', userData.companyId, 'productGroups', editingGroup.id);
        try {
            await updateDoc(groupRef, {
                name: editingGroup.name,
                defaultPurchasePrice: {
                    amount: Number(editingGroup.defaultPurchasePrice.amount) || 0,
                    currency: editingGroup.defaultPurchasePrice.currency
                }
            });
            setEditingGroup(null);
            showMessage('Grup başarıyla güncellendi!');
        } catch (error) {
            showMessage('Grup güncellenirken bir hata oluştu.', 'error');
        }
    };

    return (
        <div style={styles.formContainer}>
            <h2>Yeni Ürün Grubu Ekle</h2>
            <form onSubmit={handleAddGroup}>
                <div style={styles.formGroup}>
                    <label style={styles.label}>Grup Adı</label>
                    <input style={styles.input} type="text" name="name" value={newGroup.name} onChange={handleChange} required />
                </div>
                {canViewSensitiveData && (
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Varsayılan Alış Fiyatı</label>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <input style={{ ...styles.input, flex: 2 }} type="number" name="priceAmount" value={newGroup.defaultPurchasePrice.amount} onChange={handleChange} />
                            <select style={{ ...styles.select, flex: 1 }} name="priceCurrency" value={newGroup.defaultPurchasePrice.currency} onChange={handleChange}>
                                <option value="TRY">₺</option>
                                <option value="USD">$</option>
                            </select>
                        </div>
                    </div>
                )}
                <button type="submit" style={styles.button}>Grubu Kaydet</button>
            </form>

            <div style={styles.listContainer}>
                <h2 style={{ marginTop: '40px' }}>Mevcut Ürün Grupları</h2>
                {loading ? <p>Yükleniyor...</p> : groups.map(group => (
                    <div key={group.id} style={styles.listItem}>
                        {editingGroup?.id === group.id ? (
                            <>
                                <input style={{ ...styles.input, flex: 2 }} type="text" name="name" value={editingGroup.name} onChange={handleEditChange} />
                                {canViewSensitiveData && (
                                    <div style={{ display: 'flex', gap: '10px', flex: 2, marginLeft: '10px' }}>
                                        <input style={{ ...styles.input, flex: 2 }} type="number" name="priceAmount" value={editingGroup.defaultPurchasePrice.amount} onChange={handleEditChange} />
                                        <select style={{ ...styles.select, flex: 1 }} name="priceCurrency" value={editingGroup.defaultPurchasePrice.currency} onChange={handleEditChange}>
                                            <option value="TRY">₺</option>
                                            <option value="USD">$</option>
                                        </select>
                                    </div>
                                )}
                                <button onClick={handleSaveEdit} style={{ ...styles.button, padding: '5px 10px', fontSize: '12px', background: '#28a745', marginLeft: '10px' }}>Kaydet</button>
                                <button onClick={() => setEditingGroup(null)} style={{ ...styles.button, padding: '5px 10px', fontSize: '12px', background: '#6c757d' }}>İptal</button>
                            </>
                        ) : (
                            <>
                                <span>{group.name}</span>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                    {canViewSensitiveData && <span>{(group.defaultPurchasePrice?.amount || 0).toFixed(2)} {group.defaultPurchasePrice?.currency === 'USD' ? '$' : '₺'}</span>}
                                    <button onClick={() => setEditingGroup({ ...group, defaultPurchasePrice: group.defaultPurchasePrice || { amount: 0, currency: 'TRY' } })} style={{ ...styles.button, padding: '5px 10px', fontSize: '12px' }}>Düzenle</button>
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

function BackupSection({ userData, showMessage }) {
    const [isBackingUp, setIsBackingUp] = useState(false);

    const handleBackupAllData = async () => {
        if (!userData?.companyId) {
            showMessage('Yedekleme için şirket bilgisi bulunamadı.', 'error');
            return;
        }
        setIsBackingUp(true);
        showMessage('Yedekleme işlemi başladı, lütfen bekleyin...');

        try {
            const companyId = userData.companyId;
            const collectionsToBackup = [
                'customers', 'suppliers', 'products', 'productGroups', 'orders',
                'purchaseInvoices', 'invoices', 'transactions', 'requestedOrders',
                'activityLog', 'personnel'
            ];

            const workbook = XLSX.utils.book_new();

            for (const collectionName of collectionsToBackup) {
                const collectionRef = collection(db, 'companies', companyId, collectionName);
                const snapshot = await getDocs(query(collectionRef));
                const data = snapshot.docs.map(doc => {
                    const docData = doc.data();
                    Object.keys(docData).forEach(key => {
                        if (docData[key] instanceof Object && docData[key].seconds) {
                            docData[key] = new Date(docData[key].seconds * 1000).toLocaleString();
                        }
                    });
                    return { id: doc.id, ...docData };
                });

                if (data.length > 0) {
                    const worksheet = XLSX.utils.json_to_sheet(data);
                    XLSX.utils.book_append_sheet(workbook, worksheet, collectionName.slice(0, 31));
                }
            }

            XLSX.writeFile(workbook, `OnMuhasebe_Yedek_${new Date().toLocaleDateString().replace(/\./g, '-')}.xlsx`);
            showMessage('Tüm veriler başarıyla yedeklendi!', 'success');

        } catch (error) {
            console.error("Yedekleme sırasında hata:", error);
            showMessage('Yedekleme sırasında bir hata oluştu.', 'error');
        } finally {
            setIsBackingUp(false);
        }
    };

    return (
        <div style={styles.formContainer}>
            <h2>Veri Yedekleme</h2>
            <p style={{ color: '#6c757d', lineHeight: 1.6 }}>
                Bu bölümden tüm şirket verilerinizi (Müşteriler, Siparişler, Stoklar vb.) tek bir Excel dosyası olarak indirebilirsiniz.
                Bu işlem, veri sayınıza bağlı olarak birkaç dakika sürebilir.
            </p>
            <button
                onClick={handleBackupAllData}
                style={{ ...styles.button, background: '#198754', width: '100%', marginTop: '20px' }}
                disabled={isBackingUp}
            >
                {isBackingUp ? 'Yedekleniyor...' : 'Tüm Verileri Yedekle'}
            </button>
        </div>
    );
}



function PdfSettingsSection({ userData, showMessage }) {
    const [settings, setSettings] = useState({ logoUrl: '', primaryColor: '#2c3e50', footerText: '' });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userData?.companyId) return;
        const fetchSettings = async () => {
            const companyRef = doc(db, 'companies', userData.companyId);
            const docSnap = await getDoc(companyRef);
            if (docSnap.exists() && docSnap.data().pdfSettings) {
                setSettings(docSnap.data().pdfSettings);
            }
            setLoading(false);
        };
        fetchSettings();
    }, [userData]);

    const handleLogoUpload = (imageData) => {
        if (imageData) {
            // Cloudinary'den gelen imageData'yı kullan
            const companyRef = doc(db, 'companies', userData.companyId);
            const updatedSettings = {
                ...settings,
                logoUrl: imageData.secureUrl,
                logoData: imageData
            };

            setDoc(companyRef, { pdfSettings: updatedSettings }, { merge: true })
                .then(() => {
                    setSettings(updatedSettings);
                    showMessage('Logo başarıyla güncellendi!');
                })
                .catch((error) => {
                    console.error("Logo güncellenirken hata:", error);
                    showMessage('Logo güncellenirken bir hata oluştu.', 'error');
                });
        } else {
            // Logo kaldırıldığında
            const companyRef = doc(db, 'companies', userData.companyId);
            const updatedSettings = {
                ...settings,
                logoUrl: '',
                logoData: null
            };

            setDoc(companyRef, { pdfSettings: updatedSettings }, { merge: true })
                .then(() => {
                    setSettings(updatedSettings);
                    showMessage('Logo kaldırıldı!');
                })
                .catch((error) => {
                    console.error("Logo kaldırılırken hata:", error);
                    showMessage('Logo kaldırılırken bir hata oluştu.', 'error');
                });
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        const companyRef = doc(db, 'companies', userData.companyId);
        try {
            await setDoc(companyRef, { pdfSettings: settings }, { merge: true });
            showMessage('PDF ayarları başarıyla kaydedildi!');
        } catch (error) {
            showMessage('Ayarlar kaydedilirken bir hata oluştu.', 'error');
        }
    };

    if (loading) return <p>Yükleniyor...</p>;

    return (
        <div style={styles.formContainer}>
            <h2>PDF Tasarımı</h2>
            <form onSubmit={handleSave}>
                <div style={styles.formGroup}>
                    <label style={styles.label}>Şirket Logosu</label>
                    <ImageUpload
                        onImageUpload={handleLogoUpload}
                        currentImageUrl={settings.logoUrl}
                        label="PDF Logo"
                    />
                </div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>Ana Renk (Başlıklar için)</label>
                    <input type="color" value={settings.primaryColor} onChange={(e) => setSettings({ ...settings, primaryColor: e.target.value })} style={{ ...styles.input, height: '40px' }} />
                </div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>Alt Bilgi Metni (Banka Bilgileri, Not vb.)</label>
                    <textarea rows="4" style={styles.input} value={settings.footerText} onChange={(e) => setSettings({ ...settings, footerText: e.target.value })}></textarea>
                </div>
                <button type="submit" style={styles.button}>
                    Ayarları Kaydet
                </button>
            </form>
        </div>
    );
}

//
function CurrencySettingsSection({ userData, showMessage }) {
    const [rates, setRates] = useState({ USD: '', EUR: '', GBP: '', lastUpdated: null });
    const [loading, setLoading] = useState(true);
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        if (!userData?.companyId) return;
        const fetchRates = async () => {
            const companyRef = doc(db, 'companies', userData.companyId);
            const docSnap = await getDoc(companyRef);
            if (docSnap.exists() && docSnap.data().currencySettings) {
                setRates(docSnap.data().currencySettings);
            }
            setLoading(false);
        };
        fetchRates();
    }, [userData]);

    const handleFetchFromTCMB = async () => {
        setIsFetching(true);
        try {
            // TCMB XML API - CORS proxy kullanarak
            const corsProxy = 'https://api.allorigins.win/raw?url=';
            const tcmbUrl = 'https://www.tcmb.gov.tr/kurlar/today.xml';

            const response = await fetch(corsProxy + encodeURIComponent(tcmbUrl));

            if (!response.ok) {
                throw new Error('TCMB verisi alınamadı');
            }

            const xmlText = await response.text();
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlText, 'text/xml');

            // USD kuru
            const usdElement = xmlDoc.querySelector('Currency[Kod="USD"] ForexSelling');
            const usdRate = usdElement ? parseFloat(usdElement.textContent.replace(',', '.')) : null;

            // EUR kuru
            const eurElement = xmlDoc.querySelector('Currency[Kod="EUR"] ForexSelling');
            const eurRate = eurElement ? parseFloat(eurElement.textContent.replace(',', '.')) : null;

            // GBP kuru
            const gbpElement = xmlDoc.querySelector('Currency[Kod="GBP"] ForexSelling');
            const gbpRate = gbpElement ? parseFloat(gbpElement.textContent.replace(',', '.')) : null;

            if (usdRate || eurRate || gbpRate) {
                const newRates = {
                    ...rates,
                    USD: usdRate || rates.USD,
                    EUR: eurRate || rates.EUR,
                    GBP: gbpRate || rates.GBP
                };
                setRates(newRates);
                showMessage('TCMB\'den güncel kurlar başarıyla çekildi!', 'success');
            } else {
                throw new Error('Kur bilgileri XML\'den okunamadı');
            }
        } catch (error) {
            console.error("TCMB kur çekilirken hata:", error);
            // Alternatif yöntem dene
            try {
                // Alternatif: exchangerate-api kullan
                const altResponse = await fetch('https://open.er-api.com/v6/latest/TRY');
                const altData = await altResponse.json();

                if (altData.result === 'success' && altData.rates) {
                    const usdRate = 1 / altData.rates.USD;
                    const eurRate = 1 / altData.rates.EUR;
                    const gbpRate = 1 / altData.rates.GBP;

                    setRates({
                        ...rates,
                        USD: usdRate.toFixed(4),
                        EUR: eurRate.toFixed(4),
                        GBP: gbpRate.toFixed(4)
                    });
                    showMessage('Güncel kurlar başarıyla çekildi!', 'success');
                } else {
                    throw new Error('Alternatif API hatası');
                }
            } catch (altError) {
                console.error("Alternatif kur çekilirken hata:", altError);
                showMessage('Kurlar çekilirken bir hata oluştu. Lütfen manuel girin.', 'error');
            }
        } finally {
            setIsFetching(false);
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        const companyRef = doc(db, 'companies', userData.companyId);
        try {
            await setDoc(companyRef, {
                currencySettings: {
                    USD: Number(rates.USD) || 0,
                    EUR: Number(rates.EUR) || 0,
                    GBP: Number(rates.GBP) || 0,
                    lastUpdated: new Date()
                }
            }, { merge: true });
            showMessage('Kur ayarları başarıyla kaydedildi!');
        } catch (error) {
            showMessage('Ayarlar kaydedilirken bir hata oluştu.', 'error');
        }
    };

    if (loading) return <p>Yükleniyor...</p>;

    return (
        <div style={styles.formContainer}>
            <h2>Kur Ayarları</h2>
            <p style={{ color: '#6c757d', lineHeight: 1.6 }}>
                Dövizli işlemler için kullanılacak Türk Lirası karşılıklarını buradan yönetebilirsiniz.
                TCMB'den güncel kurları otomatik çekebilirsiniz.
            </p>

            <div style={{ marginBottom: '20px' }}>
                <button
                    type="button"
                    onClick={handleFetchFromTCMB}
                    disabled={isFetching}
                    style={{
                        ...styles.button,
                        width: '100%',
                        background: isFetching ? '#6c757d' : 'linear-gradient(135deg, #059669, #047857)',
                        boxShadow: '0 4px 12px rgba(5, 150, 105, 0.3)'
                    }}
                >
                    {isFetching ? '⏳ Kurlar Çekiliyor...' : '🏛️ TCMB\'den Güncel Kurları Çek'}
                </button>
            </div>

            <form onSubmit={handleSave}>
                <div style={styles.formGroup}>
                    <label style={styles.label}>1 ABD Doları (USD) = ? ₺</label>
                    <input
                        style={styles.input}
                        type="number"
                        step="0.0001"
                        value={rates.USD}
                        onChange={(e) => setRates({ ...rates, USD: e.target.value })}
                        placeholder="Örn: 32.50"
                    />
                </div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>1 Euro (EUR) = ? ₺</label>
                    <input
                        style={styles.input}
                        type="number"
                        step="0.0001"
                        value={rates.EUR}
                        onChange={(e) => setRates({ ...rates, EUR: e.target.value })}
                        placeholder="Örn: 35.20"
                    />
                </div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>1 İngiliz Sterlini (GBP) = ? ₺</label>
                    <input
                        style={styles.input}
                        type="number"
                        step="0.0001"
                        value={rates.GBP}
                        onChange={(e) => setRates({ ...rates, GBP: e.target.value })}
                        placeholder="Örn: 41.00"
                    />
                </div>
                {rates.lastUpdated && (
                    <p style={{ fontSize: '12px', color: '#6c757d', marginBottom: '15px' }}>
                        Son Kayıt: {rates.lastUpdated.seconds
                            ? new Date(rates.lastUpdated.seconds * 1000).toLocaleString('tr-TR')
                            : new Date(rates.lastUpdated).toLocaleString('tr-TR')}
                    </p>
                )}
                <button type="submit" style={styles.button}>Kurları Kaydet</button>
            </form>
        </div>
    );
}

//





function SystemCheckSection({ userData, showMessage }) {
    const [isChecking, setIsChecking] = useState(false);
    const [healthStatus, setHealthStatus] = useState({
        firebase: { status: 'unknown', responseTime: null, details: '' },
        firestore: { status: 'unknown', responseTime: null, details: '' },
        functions: { status: 'unknown', responseTime: null, details: '' },
        auth: { status: 'unknown', responseTime: null, details: '' },
        dataIntegrity: { status: 'unknown', issues: [], details: '' },
        connectivity: { status: 'unknown', details: '' }
    });
    const [autoRefresh, setAutoRefresh] = useState(false);
    const [lastCheck, setLastCheck] = useState(null);

    const getStatusColor = (status) => {
        switch (status) {
            case 'healthy': return '#22c55e';
            case 'warning': return '#f59e0b';
            case 'error': return '#ef4444';
            case 'checking': return '#3b82f6';
            default: return '#6b7280';
        }
    };

    const getStatusIcon = (status) => {
        switch (status) {
            case 'healthy': return '✓';
            case 'warning': return '⚠️';
            case 'error': return '❌';
            case 'checking': return '🔄';
            default: return '❓';
        }
    };

    const runSystemHealthCheck = useCallback(async () => {
        const checkFirebaseConnectivity = async () => {
            const startTime = Date.now();
            try {
                // Test basic Firebase connectivity
                const testDoc = doc(db, 'system', 'health-check');
                await getDoc(testDoc);
                const responseTime = Date.now() - startTime;
                return {
                    status: 'healthy',
                    responseTime,
                    details: `Bağlantı başarılı (${responseTime}ms)`
                };
            } catch (error) {
                return {
                    status: 'error',
                    responseTime: Date.now() - startTime,
                    details: `Bağlantı hatası: ${error.message}`
                };
            }
        };

        const checkFirestoreHealth = async () => {
            const startTime = Date.now();
            try {
                // Test Firestore read/write operations
                const companyRef = doc(db, 'companies', userData.companyId);
                const docSnap = await getDoc(companyRef);
                const responseTime = Date.now() - startTime;

                if (docSnap.exists()) {
                    return {
                        status: 'healthy',
                        responseTime,
                        details: `Veri okuma başarılı (${responseTime}ms)`
                    };
                } else {
                    return {
                        status: 'warning',
                        responseTime,
                        details: 'Şirket belgesi bulunamadı'
                    };
                }
            } catch (error) {
                return {
                    status: 'error',
                    responseTime: Date.now() - startTime,
                    details: `Firestore hatası: ${error.message}`
                };
            }
        };

        const checkFunctionsHealth = async () => {
            const startTime = Date.now();
            try {
                // First, try to check if Functions service is available
                const functionsInstance = functions;
                if (!functionsInstance) {
                    return {
                        status: 'error',
                        responseTime: Date.now() - startTime,
                        details: 'Functions servisi başlatılamadı'
                    };
                }

                // Try a simple health check function first (if available)
                try {
                    const healthCheck = httpsCallable(functions, 'healthCheck');
                    await healthCheck();
                    const responseTime = Date.now() - startTime;
                    return {
                        status: 'healthy',
                        responseTime,
                        details: `Functions sağlıklı (${responseTime}ms)`
                    };
                } catch (healthError) {
                    // If healthCheck doesn't exist, try getExchangeRates as fallback
                    try {
                        const getExchangeRates = httpsCallable(functions, 'getExchangeRates');
                        await getExchangeRates();
                        const responseTime = Date.now() - startTime;
                        return {
                            status: 'healthy',
                            responseTime,
                            details: `Functions çalışıyor (${responseTime}ms)`
                        };
                    } catch (exchangeError) {
                        const responseTime = Date.now() - startTime;

                        // Handle specific error types
                        if (exchangeError.code === 'functions/not-found') {
                            return {
                                status: 'warning',
                                responseTime,
                                details: 'Test fonksiyonları bulunamadı - Functions deployed değil'
                            };
                        } else if (exchangeError.code === 'functions/internal') {
                            return {
                                status: 'error',
                                responseTime,
                                details: 'Functions internal hatası - Backend konfigürasyonu kontrol edin'
                            };
                        } else if (exchangeError.code === 'functions/permission-denied') {
                            return {
                                status: 'error',
                                responseTime,
                                details: 'Functions izin hatası - Auth konfigürasyonu kontrol edin'
                            };
                        } else if (exchangeError.code === 'functions/unavailable') {
                            return {
                                status: 'error',
                                responseTime,
                                details: 'Functions servisi kullanılamıyor - Ağ bağlantısını kontrol edin'
                            };
                        } else {
                            return {
                                status: 'error',
                                responseTime,
                                details: `Functions hatası: ${exchangeError.code || exchangeError.message}`
                            };
                        }
                    }
                }
            } catch (error) {
                const responseTime = Date.now() - startTime;
                return {
                    status: 'error',
                    responseTime,
                    details: `Functions genel hatası: ${error.message}`
                };
            }
        };

        const checkAuthHealth = async () => {
            const startTime = Date.now();
            try {
                // Import auth from firebase to check current user
                const { auth } = await import('../../firebase');
                const currentUser = auth.currentUser;
                const responseTime = Date.now() - startTime;

                if (currentUser) {
                    return {
                        status: 'healthy',
                        responseTime,
                        details: `Kullanıcı oturumu aktif: ${currentUser.email} (${responseTime}ms)`
                    };
                } else {
                    return {
                        status: 'warning',
                        responseTime,
                        details: 'Kullanıcı oturumu bulunamadı - Auth servisi çalışıyor ancak oturum yok'
                    };
                }
            } catch (error) {
                return {
                    status: 'error',
                    responseTime: Date.now() - startTime,
                    details: `Auth hatası: ${error.message}`
                };
            }
        };

        const checkDataIntegrity = async () => {
            const startTime = Date.now();
            const issues = [];

            try {
                const companyId = userData.companyId;

                // Parallel data fetching for performance
                const [customersSnap, productsSnap, groupsSnap, ordersSnap, invoicesSnap] = await Promise.all([
                    getDocs(collection(db, 'companies', companyId, 'customers')),
                    getDocs(collection(db, 'companies', companyId, 'products')),
                    getDocs(collection(db, 'companies', companyId, 'productGroups')),
                    getDocs(collection(db, 'companies', companyId, 'orders')),
                    getDocs(collection(db, 'companies', companyId, 'invoices')),
                ]);

                const customerIds = new Set(customersSnap.docs.map(d => d.id));
                const productIds = new Set(productsSnap.docs.map(d => d.id));
                const groupIds = new Set(groupsSnap.docs.map(d => d.id));

                // Check invoice-customer relationships
                let orphanInvoices = 0;
                invoicesSnap.forEach(doc => {
                    const invoice = doc.data();
                    if (invoice.customerId && !customerIds.has(invoice.customerId)) {
                        orphanInvoices++;
                    }
                });
                if (orphanInvoices > 0) {
                    issues.push(`${orphanInvoices} fatura yetim müşteri referansı içeriyor`);
                }

                // Check order-product relationships
                let orphanProducts = 0;
                ordersSnap.forEach(doc => {
                    const order = doc.data();
                    (order.lineItems || []).forEach(item => {
                        if (item.productId && !productIds.has(item.productId)) {
                            orphanProducts++;
                        }
                    });
                });
                if (orphanProducts > 0) {
                    issues.push(`${orphanProducts} sipariş kalemi yetim ürün referansı içeriyor`);
                }

                // Check product-group relationships
                let orphanGroups = 0;
                productsSnap.forEach(doc => {
                    const product = doc.data();
                    if (product.groupId && !groupIds.has(product.groupId)) {
                        orphanGroups++;
                    }
                });
                if (orphanGroups > 0) {
                    issues.push(`${orphanGroups} ürün yetim grup referansı içeriyor`);
                }

                const responseTime = Date.now() - startTime;
                const status = issues.length === 0 ? 'healthy' : issues.length < 5 ? 'warning' : 'error';
                const details = issues.length === 0
                    ? `Veri tutarlılığı kontrol edildi (${responseTime}ms)`
                    : `${issues.length} tutarlılık sorunu tespit edildi`;

                return { status, responseTime, issues, details };

            } catch (error) {
                return {
                    status: 'error',
                    responseTime: Date.now() - startTime,
                    issues: [],
                    details: `Veri kontrolü hatası: ${error.message}`
                };
            }
        };

        const checkNetworkConnectivity = async () => {
            try {
                const startTime = Date.now();
                await fetch('https://firebase.googleapis.com/', { method: 'HEAD', mode: 'no-cors' });
                const responseTime = Date.now() - startTime;

                return {
                    status: 'healthy',
                    details: `Ağ bağlantısı stabil (${responseTime}ms)`
                };
            } catch (error) {
                return {
                    status: 'error',
                    details: `Ağ bağlantısı sorunu: ${error.message}`
                };
            }
        };

        setIsChecking(true);
        setLastCheck(new Date());

        // Update status to checking
        setHealthStatus(prev => ({
            firebase: { ...prev.firebase, status: 'checking' },
            firestore: { ...prev.firestore, status: 'checking' },
            functions: { ...prev.functions, status: 'checking' },
            auth: { ...prev.auth, status: 'checking' },
            dataIntegrity: { ...prev.dataIntegrity, status: 'checking' },
            connectivity: { ...prev.connectivity, status: 'checking' }
        }));

        try {
            // Run all health checks in parallel for better performance
            const [firebase, firestore, functions, auth, dataIntegrity, connectivity] = await Promise.all([
                checkFirebaseConnectivity(),
                checkFirestoreHealth(),
                checkFunctionsHealth(),
                checkAuthHealth(),
                checkDataIntegrity(),
                checkNetworkConnectivity()
            ]);

            setHealthStatus({
                firebase,
                firestore,
                functions,
                auth,
                dataIntegrity,
                connectivity
            });

        } catch (error) {
            console.error('System health check error:', error);
            showMessage('Sistem kontrolü sırasında bir hata oluştu.', 'error');
        } finally {
            setIsChecking(false);
        }
    }, [userData, showMessage]);

    // Auto-refresh functionality
    useEffect(() => {
        let interval;
        if (autoRefresh) {
            interval = setInterval(runSystemHealthCheck, 30000); // Refresh every 30 seconds
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [autoRefresh, runSystemHealthCheck]);

    // Initial health check on component mount
    useEffect(() => {
        runSystemHealthCheck();
    }, [runSystemHealthCheck]);

    return (
        <div style={styles.formContainer}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <h2 style={{ margin: 0 }}>Sistem Sağlık Kontrolü</h2>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#6b7280' }}>
                        <input
                            type="checkbox"
                            checked={autoRefresh}
                            onChange={(e) => setAutoRefresh(e.target.checked)}
                        />
                        Otomatik Yenile (30s)
                    </label>
                    <button
                        onClick={runSystemHealthCheck}
                        style={{
                            ...styles.button,
                            background: '#3b82f6',
                            padding: '8px 16px',
                            fontSize: '14px'
                        }}
                        disabled={isChecking}
                    >
                        {isChecking ? '🔄 Kontrol Ediliyor...' : '🔄 Yenile'}
                    </button>
                </div>
            </div>

            {lastCheck && (
                <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '20px' }}>
                    Son Kontrol: {lastCheck.toLocaleString('tr-TR')}
                </p>
            )}

            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '16px',
                marginBottom: '24px'
            }}>
                {/* Firebase Connection Status */}
                <div style={{
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '16px',
                    backgroundColor: 'white'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <h4 style={{ margin: 0, fontSize: '16px', color: '#374151' }}>Firebase Bağlantısı</h4>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            color: getStatusColor(healthStatus.firebase.status),
                            fontWeight: 'bold'
                        }}>
                            <span>{getStatusIcon(healthStatus.firebase.status)}</span>
                            <span style={{ textTransform: 'capitalize' }}>{healthStatus.firebase.status}</span>
                        </div>
                    </div>
                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                        {healthStatus.firebase.details}
                    </p>
                    {healthStatus.firebase.responseTime && (
                        <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#9ca3af' }}>
                            Yanıt Süresi: {healthStatus.firebase.responseTime}ms
                        </p>
                    )}
                </div>

                {/* Firestore Status */}
                <div style={{
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '16px',
                    backgroundColor: 'white'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <h4 style={{ margin: 0, fontSize: '16px', color: '#374151' }}>Firestore Veritabanı</h4>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            color: getStatusColor(healthStatus.firestore.status),
                            fontWeight: 'bold'
                        }}>
                            <span>{getStatusIcon(healthStatus.firestore.status)}</span>
                            <span style={{ textTransform: 'capitalize' }}>{healthStatus.firestore.status}</span>
                        </div>
                    </div>
                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                        {healthStatus.firestore.details}
                    </p>
                    {healthStatus.firestore.responseTime && (
                        <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#9ca3af' }}>
                            Yanıt Süresi: {healthStatus.firestore.responseTime}ms
                        </p>
                    )}
                </div>

                {/* Firebase Functions Status */}
                <div style={{
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '16px',
                    backgroundColor: 'white'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <h4 style={{ margin: 0, fontSize: '16px', color: '#374151' }}>Firebase Functions</h4>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            color: getStatusColor(healthStatus.functions.status),
                            fontWeight: 'bold'
                        }}>
                            <span>{getStatusIcon(healthStatus.functions.status)}</span>
                            <span style={{ textTransform: 'capitalize' }}>{healthStatus.functions.status}</span>
                        </div>
                    </div>
                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                        {healthStatus.functions.details}
                    </p>
                    {healthStatus.functions.responseTime && (
                        <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#9ca3af' }}>
                            Yanıt Süresi: {healthStatus.functions.responseTime}ms
                        </p>
                    )}
                </div>

                {/* Authentication Status */}
                <div style={{
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '16px',
                    backgroundColor: 'white'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <h4 style={{ margin: 0, fontSize: '16px', color: '#374151' }}>Kimlik Doğrulama</h4>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            color: getStatusColor(healthStatus.auth.status),
                            fontWeight: 'bold'
                        }}>
                            <span>{getStatusIcon(healthStatus.auth.status)}</span>
                            <span style={{ textTransform: 'capitalize' }}>{healthStatus.auth.status}</span>
                        </div>
                    </div>
                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                        {healthStatus.auth.details}
                    </p>
                    {healthStatus.auth.responseTime && (
                        <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#9ca3af' }}>
                            Yanıt Süresi: {healthStatus.auth.responseTime}ms
                        </p>
                    )}
                </div>

                {/* Data Integrity Status */}
                <div style={{
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '16px',
                    backgroundColor: 'white'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <h4 style={{ margin: 0, fontSize: '16px', color: '#374151' }}>Veri Bütünlüğü</h4>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            color: getStatusColor(healthStatus.dataIntegrity.status),
                            fontWeight: 'bold'
                        }}>
                            <span>{getStatusIcon(healthStatus.dataIntegrity.status)}</span>
                            <span style={{ textTransform: 'capitalize' }}>{healthStatus.dataIntegrity.status}</span>
                        </div>
                    </div>
                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                        {healthStatus.dataIntegrity.details}
                    </p>
                    {healthStatus.dataIntegrity.issues && healthStatus.dataIntegrity.issues.length > 0 && (
                        <div style={{ marginTop: '8px' }}>
                            <p style={{ margin: '0 0 4px 0', fontSize: '12px', fontWeight: 'bold', color: '#ef4444' }}>Tespit Edilen Sorunlar:</p>
                            <ul style={{ margin: 0, paddingLeft: '16px' }}>
                                {healthStatus.dataIntegrity.issues.map((issue, index) => (
                                    <li key={index} style={{ fontSize: '12px', color: '#ef4444', marginBottom: '2px' }}>
                                        {issue}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>

                {/* Network Connectivity Status */}
                <div style={{
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '16px',
                    backgroundColor: 'white'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <h4 style={{ margin: 0, fontSize: '16px', color: '#374151' }}>Ağ Bağlantısı</h4>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            color: getStatusColor(healthStatus.connectivity.status),
                            fontWeight: 'bold'
                        }}>
                            <span>{getStatusIcon(healthStatus.connectivity.status)}</span>
                            <span style={{ textTransform: 'capitalize' }}>{healthStatus.connectivity.status}</span>
                        </div>
                    </div>
                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                        {healthStatus.connectivity.details}
                    </p>
                </div>
            </div>

            {/* Overall System Status Summary */}
            <div style={{
                border: '2px solid #e5e7eb',
                borderRadius: '12px',
                padding: '20px',
                backgroundColor: '#f9fafb',
                textAlign: 'center'
            }}>
                <h3 style={{ margin: '0 0 12px 0', fontSize: '18px', color: '#374151' }}>Genel Sistem Durumu</h3>
                {(() => {
                    const statuses = Object.values(healthStatus).map(s => s.status);
                    const hasError = statuses.includes('error');
                    const hasWarning = statuses.includes('warning');
                    const isChecking = statuses.includes('checking');

                    let overallStatus, message, color;
                    if (isChecking) {
                        overallStatus = 'Kontrol Ediliyor';
                        message = 'Sistem durumu kontrol ediliyor...';
                        color = '#3b82f6';
                    } else if (hasError) {
                        overallStatus = 'Kritik Sorunlar Var';
                        message = 'Sistemde kritik sorunlar tespit edildi. Lütfen teknik destek ile iletişime geçin.';
                        color = '#ef4444';
                    } else if (hasWarning) {
                        overallStatus = 'Uyarılar Mevcut';
                        message = 'Sistemde bazı uyarılar var ancak çalışmaya devam edebilirsiniz.';
                        color = '#f59e0b';
                    } else {
                        overallStatus = 'Sistem Sağlıklı';
                        message = 'Tüm sistemler normal çalışıyor.';
                        color = '#22c55e';
                    }

                    return (
                        <>
                            <div style={{
                                fontSize: '24px',
                                fontWeight: 'bold',
                                color,
                                marginBottom: '8px'
                            }}>
                                {overallStatus}
                            </div>
                            <p style={{ margin: 0, color: '#6b7280', fontSize: '14px' }}>
                                {message}
                            </p>
                        </>
                    );
                })()}
            </div>
        </div>
    );
}

// Activity Tracking Section
function ActivityTrackingSection({ userData, showMessage }) {
    const navigate = useNavigate();
    const [activityStats, setActivityStats] = useState({
        totalActivities: 0,
        todayActivities: 0,
        activeUsers: 0,
        lastWeekActivities: 0
    });
    const [recentActivities, setRecentActivities] = useState([]);
    const [trackingSettings, setTrackingSettings] = useState({
        enablePageTracking: true,
        enableSearchTracking: true,
        enableErrorTracking: true,
        enableDetailedLogging: true,
        retentionDays: 90
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userData?.companyId) return;

        const fetchActivityStats = async () => {
            try {
                const companyId = userData.companyId;
                const today = new Date();
                const weekAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
                const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());

                // Get recent activities
                const activitiesRef = collection(db, 'companies', companyId, 'globalActivities');
                const recentQuery = query(
                    activitiesRef,
                    orderBy('timestamp', 'desc'),
                    limit(20)
                );

                const unsubscribe = onSnapshot(recentQuery, (snapshot) => {
                    const activities = snapshot.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }));

                    setRecentActivities(activities);

                    // Calculate stats
                    const stats = {
                        totalActivities: activities.length,
                        todayActivities: activities.filter(activity => {
                            const activityDate = activity.timestamp?.toDate?.() || new Date(activity.formattedDate);
                            return activityDate >= todayStart;
                        }).length,
                        lastWeekActivities: activities.filter(activity => {
                            const activityDate = activity.timestamp?.toDate?.() || new Date(activity.formattedDate);
                            return activityDate >= weekAgo;
                        }).length,
                        activeUsers: new Set(activities.map(a => a.userId)).size
                    };

                    setActivityStats(stats);
                    setLoading(false);
                });

                return () => unsubscribe();
            } catch (error) {
                console.error('Error fetching activity stats:', error);
                setLoading(false);
            }
        };

        fetchActivityStats();
    }, [userData]);

    const handleSettingsUpdate = async () => {
        try {
            const settingsRef = doc(db, 'companies', userData.companyId, 'settings', 'activityTracking');
            await setDoc(settingsRef, {
                ...trackingSettings,
                updatedAt: new Date(),
                updatedBy: userData.email
            });
            showMessage('Aktivite izleme ayarları başarıyla güncellendi!');
        } catch (error) {
            console.error('Error updating activity settings:', error);
            showMessage('Ayarlar güncellenirken bir hata oluştu.', 'error');
        }
    };

    const handleExportData = async () => {
        try {
            const activitiesRef = collection(db, 'companies', userData.companyId, 'globalActivities');
            const exportQuery = query(
                activitiesRef,
                orderBy('timestamp', 'desc'),
                limit(1000)
            );

            const snapshot = await getDocs(exportQuery);
            const activities = snapshot.docs.map(doc => ({
                'Tarih': doc.data().formattedDate || 'Bilinmiyor',
                'Kullanıcı': doc.data().userName || doc.data().userEmail || 'Bilinmiyor',
                'Rol': doc.data().userRole || 'kullanıcı',
                'İşlem': doc.data().activityMessage || 'Bilinmeyen işlem',
                'Modül': doc.data().entityType || 'sistem',
                'Hedef': doc.data().entityName || '-',
                'IP Adresi': doc.data().ipAddress || 'Bilinmiyor',
                'Durum': doc.data().details?.success !== false ? 'Başarılı' : 'Hatalı'
            }));

            const ws = XLSX.utils.json_to_sheet(activities);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Aktivite Kayıtları');

            const fileName = `aktivite_kayitlari_${new Date().toLocaleDateString('tr-TR').replace(/\./g, '-')}.xlsx`;
            XLSX.writeFile(wb, fileName);

            showMessage('Aktivite kayıtları başarıyla dışa aktarıldı!');
        } catch (error) {
            console.error('Error exporting activity data:', error);
            showMessage('Dışa aktarım sırasında bir hata oluştu.', 'error');
        }
    };

    const formatActivityIcon = (activityType) => {
        const icons = {
            kullanici_giris: '🔐',
            kullanici_cikis: '🚪',
            siparis_olusturuldu: '✨',
            siparis_guncellendi: '✏️',
            musteri_olusturuldu: '👤',
            urun_olusturuldu: '📦',
            fatura_olusturuldu: '📄',
            sayfa_ziyaret: '🌐',
            arama_yapildi: '🔍',
            disa_aktar: '📊',
            hata_olustu: '⚠️'
        };
        return icons[activityType] || '📝';
    };

    if (loading) {
        return (
            <div style={{ textAlign: 'center', padding: '40px' }}>
                <div style={{ fontSize: '16px', color: '#6b7280' }}>Aktivite verileri yükleniyor...</div>
            </div>
        );
    }

    return (
        <div>
            <h2 style={{ margin: '0 0 24px 0', fontSize: '24px', color: '#0f172a' }}>Aktivite İzleme Yönetimi</h2>

            {/* Activity Statistics */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '20px',
                marginBottom: '32px'
            }}>
                <div style={{
                    background: 'linear-gradient(135deg, #06C167, #764ba2)',
                    color: 'white',
                    padding: '24px',
                    borderRadius: '12px',
                    textAlign: 'center'
                }}>
                    <div style={{ fontSize: '32px', fontWeight: '700', marginBottom: '8px' }}>
                        {activityStats.totalActivities}
                    </div>
                    <div style={{ fontSize: '14px', opacity: 0.9 }}>Son Aktiviteler</div>
                </div>

                <div style={{
                    background: 'linear-gradient(135deg, #f093fb, #f5576c)',
                    color: 'white',
                    padding: '24px',
                    borderRadius: '12px',
                    textAlign: 'center'
                }}>
                    <div style={{ fontSize: '32px', fontWeight: '700', marginBottom: '8px' }}>
                        {activityStats.todayActivities}
                    </div>
                    <div style={{ fontSize: '14px', opacity: 0.9 }}>Bugün</div>
                </div>

                <div style={{
                    background: 'linear-gradient(135deg, #4facfe, #00f2fe)',
                    color: 'white',
                    padding: '24px',
                    borderRadius: '12px',
                    textAlign: 'center'
                }}>
                    <div style={{ fontSize: '32px', fontWeight: '700', marginBottom: '8px' }}>
                        {activityStats.activeUsers}
                    </div>
                    <div style={{ fontSize: '14px', opacity: 0.9 }}>Aktif Kullanıcı</div>
                </div>

                <div style={{
                    background: 'linear-gradient(135deg, #43e97b, #38f9d7)',
                    color: 'white',
                    padding: '24px',
                    borderRadius: '12px',
                    textAlign: 'center'
                }}>
                    <div style={{ fontSize: '32px', fontWeight: '700', marginBottom: '8px' }}>
                        {activityStats.lastWeekActivities}
                    </div>
                    <div style={{ fontSize: '14px', opacity: 0.9 }}>Son 7 Gün</div>
                </div>
            </div>

            {/* Quick Actions */}
            <div style={{
                background: '#f8fafc',
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                padding: '24px',
                marginBottom: '32px'
            }}>
                <h3 style={{ margin: '0 0 16px 0', fontSize: '18px', color: '#374151' }}>Hızlı İşlemler</h3>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    <button
                        onClick={() => navigate('/kullanici-aktiviteleri')}
                        style={{
                            ...styles.button,
                            background: 'linear-gradient(135deg, #06C167, #8b5cf6)'
                        }}
                    >
                        📊 Detaylı Aktivite Dashboard
                    </button>
                    <button
                        onClick={handleExportData}
                        style={{
                            ...styles.button,
                            background: 'linear-gradient(135deg, #059669, #047857)'
                        }}
                    >
                        📋 Aktivite Verilerini Dışa Aktar
                    </button>
                </div>
            </div>

            {/* Tracking Settings */}
            <div style={{
                background: 'white',
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                padding: '24px',
                marginBottom: '32px'
            }}>
                <h3 style={{ margin: '0 0 20px 0', fontSize: '18px', color: '#374151' }}>İzleme Ayarları</h3>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                    gap: '16px',
                    marginBottom: '20px'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '12px',
                        background: '#f8fafc',
                        borderRadius: '8px',
                        border: '1px solid #e2e8f0'
                    }}>
                        <input
                            type="checkbox"
                            checked={trackingSettings.enablePageTracking}
                            onChange={(e) => setTrackingSettings(prev => ({
                                ...prev,
                                enablePageTracking: e.target.checked
                            }))}
                            style={{ transform: 'scale(1.2)' }}
                        />
                        <div>
                            <div style={{ fontWeight: '600', fontSize: '14px', color: '#374151' }}>
                                Sayfa Ziyaret Takibi
                            </div>
                            <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                Kullanıcıların sayfa geçişlerini izle
                            </div>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '12px',
                        background: '#f8fafc',
                        borderRadius: '8px',
                        border: '1px solid #e2e8f0'
                    }}>
                        <input
                            type="checkbox"
                            checked={trackingSettings.enableSearchTracking}
                            onChange={(e) => setTrackingSettings(prev => ({
                                ...prev,
                                enableSearchTracking: e.target.checked
                            }))}
                            style={{ transform: 'scale(1.2)' }}
                        />
                        <div>
                            <div style={{ fontWeight: '600', fontSize: '14px', color: '#374151' }}>
                                Arama Takibi
                            </div>
                            <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                Kullanıcı arama davranışlarını izle
                            </div>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '12px',
                        background: '#f8fafc',
                        borderRadius: '8px',
                        border: '1px solid #e2e8f0'
                    }}>
                        <input
                            type="checkbox"
                            checked={trackingSettings.enableErrorTracking}
                            onChange={(e) => setTrackingSettings(prev => ({
                                ...prev,
                                enableErrorTracking: e.target.checked
                            }))}
                            style={{ transform: 'scale(1.2)' }}
                        />
                        <div>
                            <div style={{ fontWeight: '600', fontSize: '14px', color: '#374151' }}>
                                Hata Takibi
                            </div>
                            <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                Sistem hatalarını ve sorunları izle
                            </div>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '12px',
                        background: '#f8fafc',
                        borderRadius: '8px',
                        border: '1px solid #e2e8f0'
                    }}>
                        <input
                            type="checkbox"
                            checked={trackingSettings.enableDetailedLogging}
                            onChange={(e) => setTrackingSettings(prev => ({
                                ...prev,
                                enableDetailedLogging: e.target.checked
                            }))}
                            style={{ transform: 'scale(1.2)' }}
                        />
                        <div>
                            <div style={{ fontWeight: '600', fontSize: '14px', color: '#374151' }}>
                                Detaylı Kayıt
                            </div>
                            <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                IP adresi, cihaz bilgisi gibi detayları kaydet
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <label style={styles.label}>Veri Saklama Süresi (Gün)</label>
                    <select
                        style={{ ...styles.input, width: '200px' }}
                        value={trackingSettings.retentionDays}
                        onChange={(e) => setTrackingSettings(prev => ({
                            ...prev,
                            retentionDays: parseInt(e.target.value)
                        }))}
                    >
                        <option value={30}>30 Gün</option>
                        <option value={60}>60 Gün</option>
                        <option value={90}>90 Gün</option>
                        <option value={180}>6 Ay</option>
                        <option value={365}>1 Yıl</option>
                    </select>
                </div>

                <button onClick={handleSettingsUpdate} style={styles.button}>
                    Ayarları Kaydet
                </button>
            </div>

            {/* Recent Activities */}
            <div style={{
                background: 'white',
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                padding: '24px'
            }}>
                <h3 style={{ margin: '0 0 20px 0', fontSize: '18px', color: '#374151' }}>Son Aktiviteler</h3>

                {recentActivities.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
                        <div style={{ fontSize: '48px', marginBottom: '16px' }}>📝</div>
                        <div>Henüz aktivite kaydı bulunmuyor</div>
                    </div>
                ) : (
                    <div style={{
                        maxHeight: '400px',
                        overflowY: 'auto',
                        border: '1px solid #f1f5f9',
                        borderRadius: '8px'
                    }}>
                        {recentActivities.map((activity, index) => (
                            <div
                                key={activity.id}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '16px',
                                    padding: '16px',
                                    borderBottom: index < recentActivities.length - 1 ? '1px solid #f8fafc' : 'none',
                                    transition: 'background 0.2s'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.background = '#f8fafc'}
                                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                            >
                                <div style={{ fontSize: '20px', minWidth: '20px' }}>
                                    {formatActivityIcon(activity.activityType)}
                                </div>
                                <div style={{ flex: 1 }}>
                                    <div style={{
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#1a1d29',
                                        marginBottom: '4px'
                                    }}>
                                        {activity.activityMessage || 'Bilinmeyen işlem'}
                                    </div>
                                    <div style={{
                                        fontSize: '12px',
                                        color: '#6b7280',
                                        marginBottom: '2px'
                                    }}>
                                        👤 {activity.userName || activity.userEmail?.split('@')[0] || 'Bilinmeyen kullanıcı'}
                                        {activity.userRole && activity.userRole !== 'kullanıcı' && (
                                            <span style={{ marginLeft: '8px', textTransform: 'uppercase' }}>
                                                ({activity.userRole})
                                            </span>
                                        )}
                                    </div>
                                    <div style={{
                                        fontSize: '11px',
                                        color: '#9ca3af'
                                    }}>
                                        {activity.formattedDate ||
                                            (activity.timestamp?.toDate?.()?.toLocaleString('tr-TR') || 'Tarih bilinmiyor')}
                                        {activity.entityType && activity.entityType !== 'system' && (
                                            <span style={{ marginLeft: '8px' }}>
                                                • {activity.entityType}
                                                {activity.entityName && ` (${activity.entityName})`}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div style={{
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    background: activity.details?.success !== false ? '#dcfce7' : '#fef2f2',
                                    color: activity.details?.success !== false ? '#166534' : '#dc2626'
                                }}>
                                    {activity.details?.success !== false ? 'Başarılı' : 'Hatalı'}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

// API Ayarları Bileşeni
function APISettingsSection({ userData, showMessage }) {
    const [apiSettings, setApiSettings] = useState({
        geminiApiKey: '',
        geminiModelId: DEFAULT_GEMINI_MODEL,
        customGeminiModels: [] // Array of { id, name }
    });
    const [isSaving, setIsSaving] = useState(false);
    const [showApiKey, setShowApiKey] = useState(false);

    // New model inputs
    const [newModelId, setNewModelId] = useState('');
    const [newModelName, setNewModelName] = useState('');
    const [isAddingModel, setIsAddingModel] = useState(false);

    // API ayarlarını yükle
    useEffect(() => {
        const fetchSettings = async () => {
            if (!userData?.companyId) return;
            try {
                const docRef = doc(db, 'companies', userData.companyId, 'settings', 'apiKeys');
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setApiSettings({
                        ...data,
                        customGeminiModels: data.customGeminiModels || []
                    });
                }
            } catch (err) {
                console.error('API ayarları yüklenemedi:', err);
            }
        };
        fetchSettings();
    }, [userData?.companyId]);

    const handleSave = async (e) => {
        e.preventDefault();
        if (!userData?.companyId) return;

        setIsSaving(true);
        try {
            const docRef = doc(db, 'companies', userData.companyId, 'settings', 'apiKeys');
            await setDoc(docRef, {
                ...apiSettings,
                updatedAt: new Date()
            }, { merge: true });
            showMessage('API ayarları başarıyla kaydedildi.');
        } catch (err) {
            showMessage('API ayarları kaydedilirken hata oluştu: ' + err.message, 'error');
        }
        setIsSaving(false);
    };

    const handleAddCustomModel = (e) => {
        e.preventDefault(); // Prevent form submission
        if (!newModelId || !newModelName) {
            showMessage('Lütfen model ID ve ismini girin.', 'error');
            return;
        }

        // Check if ID is already used
        if (GEMINI_MODELS.some(m => m.id === newModelId) || apiSettings.customGeminiModels?.some(m => m.id === newModelId)) {
            showMessage('Bu Model ID zaten kullanımda.', 'error');
            return;
        }

        const newModel = { id: newModelId, name: newModelName, isCustom: true };
        const updatedModels = [...(apiSettings.customGeminiModels || []), newModel];

        setApiSettings(prev => ({
            ...prev,
            customGeminiModels: updatedModels
        }));

        setNewModelId('');
        setNewModelName('');
        setIsAddingModel(false);
        showMessage('Özel model listeye eklendi. Ayarları kaydetmeyi unutmayın.');
    };

    const handleRemoveCustomModel = (modelId) => {
        const updatedModels = (apiSettings.customGeminiModels || []).filter(m => m.id !== modelId);
        setApiSettings(prev => ({
            ...prev,
            customGeminiModels: updatedModels,
            geminiModelId: prev.geminiModelId === modelId ? DEFAULT_GEMINI_MODEL : prev.geminiModelId
        }));
        showMessage('Model listeden kaldırıldı. Ayarları kaydetmeyi unutmayın.');
    };

    const allModels = [...GEMINI_MODELS, ...(apiSettings.customGeminiModels || [])];

    return (
        <div>
            <h2 style={styles.sectionTitle}>🔑 API Anahtarları</h2>
            <p style={{ color: '#64748b', marginBottom: '24px' }}>
                Yapay zeka ve üçüncü parti servisler için API anahtarlarınızı buradan yönetin.
            </p>

            <form onSubmit={handleSave}>
                {/* Gemini API */}
                <div style={{
                    background: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    borderRadius: '12px',
                    padding: '24px',
                    marginBottom: '20px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                        <span style={{ fontSize: '32px' }}>🤖</span>
                        <div>
                            <h3 style={{ margin: 0, fontSize: '16px', color: '#0f172a' }}>Google Gemini API</h3>
                            <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#64748b' }}>
                                Görsel Hazırlama modülü için yapay zeka servisi
                            </p>
                        </div>
                    </div>

                    <div style={{ marginBottom: '16px' }}>
                        <label style={styles.label}>API Anahtarı</label>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <input
                                type={showApiKey ? 'text' : 'password'}
                                style={{ ...styles.input, flex: 1 }}
                                value={apiSettings.geminiApiKey || ''}
                                onChange={(e) => setApiSettings(prev => ({
                                    ...prev,
                                    geminiApiKey: e.target.value
                                }))}
                                placeholder="AIzaSy... şeklinde API anahtarınızı girin"
                            />
                            <button
                                type="button"
                                onClick={() => setShowApiKey(!showApiKey)}
                                style={{
                                    padding: '10px 16px',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: '8px',
                                    background: 'white',
                                    cursor: 'pointer',
                                    fontSize: '14px'
                                }}
                            >
                                {showApiKey ? '🙈 Gizle' : '👁️ Göster'}
                            </button>
                        </div>
                    </div>

                    <div style={{ marginBottom: '16px' }}>
                        <label style={styles.label}>Yapay Zeka Modeli</label>
                        <select
                            style={styles.input}
                            value={allModels.some(m => m.id === apiSettings.geminiModelId) ? apiSettings.geminiModelId : ''}
                            onChange={(e) => setApiSettings(prev => ({ ...prev, geminiModelId: e.target.value }))}
                        >
                            <optgroup label="Standart Modeller">
                                {GEMINI_MODELS.map(model => (
                                    <option key={model.id} value={model.id}>
                                        {model.name} {model.supportsImageGen ? '(Önerilen)' : ''}
                                    </option>
                                ))}
                            </optgroup>

                            {apiSettings.customGeminiModels && apiSettings.customGeminiModels.length > 0 && (
                                <optgroup label="Özel Modelleriniz">
                                    {apiSettings.customGeminiModels.map(model => (
                                        <option key={model.id} value={model.id}>
                                            {model.name} (Özel)
                                        </option>
                                    ))}
                                </optgroup>
                            )}
                        </select>

                        <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                            {allModels.find(m => m.id === apiSettings.geminiModelId)?.description ||
                                (apiSettings.customGeminiModels?.find(m => m.id === apiSettings.geminiModelId) && 'Kullanıcı tanımlı özel model')}
                        </div>
                    </div>

                    {/* Custom Model Management */}
                    <div style={{ marginBottom: '16px' }}>
                        <button
                            type="button"
                            onClick={() => setIsAddingModel(!isAddingModel)}
                            style={{
                                background: 'transparent',
                                border: '1px dashed #06C167',
                                color: '#06C167',
                                padding: '8px 12px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '13px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <span>{isAddingModel ? '➖ İptal Et' : '➕ Özel Model Ekle'}</span>
                        </button>

                        {isAddingModel && (
                            <div style={{
                                marginTop: '12px',
                                padding: '16px',
                                background: '#eef2ff',
                                borderRadius: '8px',
                                border: '1px solid #e0e7ff'
                            }}>
                                <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#374151' }}>Yeni Model Tanımla</h4>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px', color: '#6b7280' }}>Model ID</label>
                                        <input
                                            type="text"
                                            style={styles.input}
                                            value={newModelId}
                                            onChange={(e) => setNewModelId(e.target.value)}
                                            placeholder="gemini-1.5-pro-exp-0827"
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px', color: '#6b7280' }}>Görünen İsim</label>
                                        <input
                                            type="text"
                                            style={styles.input}
                                            value={newModelName}
                                            onChange={(e) => setNewModelName(e.target.value)}
                                            placeholder="Gemini Pro Experimental"
                                        />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <button
                                        type="button"
                                        onClick={handleAddCustomModel}
                                        style={{
                                            ...styles.button,
                                            padding: '8px 16px',
                                            fontSize: '13px'
                                        }}
                                    >
                                        Listeye Ekle
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* List Custom Models to allow deletion */}
                        {apiSettings.customGeminiModels && apiSettings.customGeminiModels.length > 0 && (
                            <div style={{ marginTop: '12px' }}>
                                <label style={{ fontSize: '12px', display: 'block', marginBottom: '6px', color: '#6b7280' }}>Kayıtlı Özel Modeller:</label>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                    {apiSettings.customGeminiModels.map(model => (
                                        <div key={model.id} style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            padding: '4px 8px',
                                            background: 'white',
                                            border: '1px solid #e2e8f0',
                                            borderRadius: '6px',
                                            fontSize: '12px'
                                        }}>
                                            <span style={{ fontWeight: '500' }}>{model.name}</span>
                                            <span style={{ color: '#9ca3af', fontSize: '11px' }}>({model.id})</span>
                                            <button
                                                type="button"
                                                onClick={() => handleRemoveCustomModel(model.id)}
                                                style={{
                                                    border: 'none',
                                                    background: 'none',
                                                    color: '#ef4444',
                                                    cursor: 'pointer',
                                                    padding: '2px',
                                                    marginLeft: '4px',
                                                    fontSize: '14px'
                                                }}
                                                title="Sil"
                                            >
                                                &times;
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    <div style={{
                        padding: '12px 16px',
                        background: '#eff6ff',
                        border: '1px solid #bfdbfe',
                        borderRadius: '8px',
                        fontSize: '13px',
                        color: '#1e40af'
                    }}>
                        <strong>💡 API Anahtarı Nasıl Alınır?</strong>
                        <ol style={{ margin: '8px 0 0 0', paddingLeft: '20px' }}>
                            <li><a href="https://aistudio.google.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb' }}>Google AI Studio</a> adresine gidin</li>
                            <li>Google hesabınızla giriş yapın</li>
                            <li>"Create API Key" butonuna tıklayın</li>
                            <li>Oluşturulan anahtarı buraya yapıştırın</li>
                        </ol>
                    </div>
                </div>

                <button
                    type="submit"
                    disabled={isSaving}
                    style={{
                        ...styles.button,
                        opacity: isSaving ? 0.7 : 1
                    }}
                >
                    {isSaving ? 'Kaydediliyor...' : '💾 Ayarları Kaydet'}
                </button>
            </form>

            <div style={{
                marginTop: '32px',
                padding: '16px',
                background: '#fef3c7',
                border: '1px solid #f59e0b',
                borderRadius: '8px'
            }}>
                <strong style={{ color: '#92400e' }}>⚠️ Güvenlik Notu:</strong>
                <p style={{ margin: '8px 0 0 0', fontSize: '14px', color: '#92400e' }}>
                    API anahtarlarınız şifreli olarak saklanır ve sadece sizin firmanız tarafından kullanılabilir.
                    Anahtarlarınızı kimseyle paylaşmayın.
                </p>
            </div>
        </div>
    );
}

// Veri Aktarım Bileşeni
function DataMigrationSection({ userData, showMessage }) {
    const [importing, setImporting] = useState({ customers: false, suppliers: false, products: false, orders: false });
    const [importResults, setImportResults] = useState({ customers: null, suppliers: null, products: null, orders: null });

    // Müşteri Şablonu İndir
    const downloadCustomerTemplate = () => {
        const templateData = [{
            musteri_adi: 'Örnek Müşteri',
            musteri_tipi: 'bireysel',
            email: 'ornek@email.com',
            telefon: '05551234567',
            il: 'İstanbul',
            ilce: 'Kadıköy',
            adres: 'Örnek Mah. Örnek Sk. No:1',
            vergi_dairesi: 'Kadıköy VD',
            vergi_no: '1234567890',
            para_birimi: 'TRY',
            bakiye: 0
        }];
        const ws = XLSX.utils.json_to_sheet(templateData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Müşteriler');
        XLSX.writeFile(wb, 'musteri_aktarim_sablonu.xlsx');
    };

    // Tedarikçi Şablonu İndir
    const downloadSupplierTemplate = () => {
        const templateData = [{
            tedarikci_adi: 'Örnek Tedarikçi',
            email: 'tedarikci@email.com',
            telefon: '05551234567',
            adres: 'Örnek Mah. Örnek Sk. No:1',
            vergi_dairesi: 'Merkez VD',
            vergi_no: '9876543210',
            para_birimi: 'TRY',
            bakiye: 0
        }];
        const ws = XLSX.utils.json_to_sheet(templateData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Tedarikçiler');
        XLSX.writeFile(wb, 'tedarikci_aktarim_sablonu.xlsx');
    };

    // Ürün Şablonu İndir
    const downloadProductTemplate = () => {
        const templateData = [{
            urun_adi: 'Örnek Ürün',
            barkod: '8690123456789',
            grup_adi: 'Genel',
            birim: 'Adet',
            miktar: 100,
            satis_fiyati: 99.90,
            kritik_seviye: 10
        }];
        const ws = XLSX.utils.json_to_sheet(templateData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Ürünler');
        XLSX.writeFile(wb, 'urun_aktarim_sablonu.xlsx');
    };

    // Müşteri Import
    const handleCustomerImport = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setImporting(prev => ({ ...prev, customers: true }));
        setImportResults(prev => ({ ...prev, customers: null }));

        const reader = new FileReader();
        reader.onload = async (evt) => {
            try {
                const data = new Uint8Array(evt.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                const json = XLSX.utils.sheet_to_json(sheet);

                let successCount = 0;
                let errorCount = 0;
                const errors = [];

                for (const item of json) {
                    try {
                        await addDoc(collection(db, 'companies', userData.companyId, 'customers'), {
                            name: item.musteri_adi || '',
                            type: item.musteri_tipi || 'bireysel',
                            email: item.email || '',
                            phone: item.telefon || '',
                            city: item.il || '',
                            district: item.ilce || '',
                            address: item.adres || '',
                            taxOffice: item.vergi_dairesi || '',
                            taxNumber: item.vergi_no || '',
                            currency: item.para_birimi || 'TRY',
                            balance: Number(item.bakiye) || 0,
                            createdAt: new Date()
                        });
                        successCount++;
                    } catch (err) {
                        errorCount++;
                        errors.push(`${item.musteri_adi}: ${err.message}`);
                    }
                }

                setImportResults(prev => ({
                    ...prev,
                    customers: { success: successCount, error: errorCount, errors }
                }));
                showMessage(`${successCount} müşteri başarıyla aktarıldı.${errorCount > 0 ? ` ${errorCount} hata oluştu.` : ''}`, errorCount > 0 ? 'error' : 'success');
            } catch (err) {
                showMessage('Excel dosyası okunurken hata oluştu: ' + err.message, 'error');
            }
            setImporting(prev => ({ ...prev, customers: false }));
        };
        reader.readAsArrayBuffer(file);
        e.target.value = '';
    };

    // Tedarikçi Import
    const handleSupplierImport = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setImporting(prev => ({ ...prev, suppliers: true }));
        setImportResults(prev => ({ ...prev, suppliers: null }));

        const reader = new FileReader();
        reader.onload = async (evt) => {
            try {
                const data = new Uint8Array(evt.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                const json = XLSX.utils.sheet_to_json(sheet);

                let successCount = 0;
                let errorCount = 0;
                const errors = [];

                for (const item of json) {
                    try {
                        await addDoc(collection(db, 'companies', userData.companyId, 'suppliers'), {
                            name: item.tedarikci_adi || '',
                            email: item.email || '',
                            phone: item.telefon || '',
                            address: item.adres || '',
                            taxOffice: item.vergi_dairesi || '',
                            taxNumber: item.vergi_no || '',
                            currency: item.para_birimi || 'TRY',
                            balance: Number(item.bakiye) || 0,
                            createdAt: new Date()
                        });
                        successCount++;
                    } catch (err) {
                        errorCount++;
                        errors.push(`${item.tedarikci_adi}: ${err.message}`);
                    }
                }

                setImportResults(prev => ({
                    ...prev,
                    suppliers: { success: successCount, error: errorCount, errors }
                }));
                showMessage(`${successCount} tedarikçi başarıyla aktarıldı.${errorCount > 0 ? ` ${errorCount} hata oluştu.` : ''}`, errorCount > 0 ? 'error' : 'success');
            } catch (err) {
                showMessage('Excel dosyası okunurken hata oluştu: ' + err.message, 'error');
            }
            setImporting(prev => ({ ...prev, suppliers: false }));
        };
        reader.readAsArrayBuffer(file);
        e.target.value = '';
    };

    // Ürün Import
    const handleProductImport = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setImporting(prev => ({ ...prev, products: true }));
        setImportResults(prev => ({ ...prev, products: null }));

        // First get product groups
        const groupsSnap = await getDocs(collection(db, 'companies', userData.companyId, 'productGroups'));
        const groups = groupsSnap.docs.map(d => ({ id: d.id, ...d.data() }));

        const reader = new FileReader();
        reader.onload = async (evt) => {
            try {
                const data = new Uint8Array(evt.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                const json = XLSX.utils.sheet_to_json(sheet);

                let successCount = 0;
                let errorCount = 0;
                const errors = [];

                for (const item of json) {
                    try {
                        const group = groups.find(g => g.name === item.grup_adi);
                        await addDoc(collection(db, 'companies', userData.companyId, 'products'), {
                            name: item.urun_adi || '',
                            barcode: String(item.barkod || ''),
                            groupId: group?.id || '',
                            unit: item.birim || 'Adet',
                            quantity: Number(item.miktar) || 0,
                            salePrice: Number(item.satis_fiyati) || 0,
                            criticalLevel: Number(item.kritik_seviye) || 10,
                            warehouseQuantities: {},
                            createdAt: new Date()
                        });
                        successCount++;
                    } catch (err) {
                        errorCount++;
                        errors.push(`${item.urun_adi}: ${err.message}`);
                    }
                }

                setImportResults(prev => ({
                    ...prev,
                    products: { success: successCount, error: errorCount, errors }
                }));
                showMessage(`${successCount} ürün başarıyla aktarıldı.${errorCount > 0 ? ` ${errorCount} hata oluştu.` : ''}`, errorCount > 0 ? 'error' : 'success');
            } catch (err) {
                showMessage('Excel dosyası okunurken hata oluştu: ' + err.message, 'error');
            }
            setImporting(prev => ({ ...prev, products: false }));
        };
        reader.readAsArrayBuffer(file);
        e.target.value = '';
    };

    // Sipariş Şablonu İndir
    const downloadOrderTemplate = () => {
        const templateData = [{
            siparis_no: 'SIP-001',
            musteri_adi: 'Örnek Müşteri',
            tarih: '2024-01-15',
            durum: 'Tamamlandı',
            toplam_tutar: 1500.00,
            odeme_durumu: 'Ödendi',
            not: 'Örnek sipariş notu'
        }];
        const ws = XLSX.utils.json_to_sheet(templateData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Siparisler');
        XLSX.writeFile(wb, 'siparis_aktarim_sablonu.xlsx');
    };

    // Sipariş Import
    const handleOrderImport = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setImporting(prev => ({ ...prev, orders: true }));
        setImportResults(prev => ({ ...prev, orders: null }));

        // Get customers for matching
        const customersSnap = await getDocs(collection(db, 'companies', userData.companyId, 'customers'));
        const customers = customersSnap.docs.map(d => ({ id: d.id, ...d.data() }));

        const reader = new FileReader();
        reader.onload = async (evt) => {
            try {
                const data = new Uint8Array(evt.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                const json = XLSX.utils.sheet_to_json(sheet);

                let successCount = 0;
                let errorCount = 0;
                const errors = [];

                for (const item of json) {
                    try {
                        const customer = customers.find(c => c.name === item.musteri_adi);
                        await addDoc(collection(db, 'companies', userData.companyId, 'orders'), {
                            orderNumber: item.siparis_no || `IMP-${Date.now()}`,
                            customerId: customer?.id || '',
                            customerName: item.musteri_adi || '',
                            orderDate: item.tarih ? new Date(item.tarih) : new Date(),
                            status: item.durum || 'Beklemede',
                            totalAmount: Number(item.toplam_tutar) || 0,
                            paymentStatus: item.odeme_durumu || 'Bekliyor',
                            notes: item.not || '',
                            items: [],
                            createdAt: new Date(),
                            importedFromExcel: true
                        });
                        successCount++;
                    } catch (err) {
                        errorCount++;
                        errors.push(`${item.siparis_no}: ${err.message}`);
                    }
                }

                setImportResults(prev => ({
                    ...prev,
                    orders: { success: successCount, error: errorCount, errors }
                }));
                showMessage(`${successCount} sipariş başarıyla aktarıldı.${errorCount > 0 ? ` ${errorCount} hata oluştu.` : ''}`, errorCount > 0 ? 'error' : 'success');
            } catch (err) {
                showMessage('Excel dosyası okunurken hata oluştu: ' + err.message, 'error');
            }
            setImporting(prev => ({ ...prev, orders: false }));
        };
        reader.readAsArrayBuffer(file);
        e.target.value = '';
    };

    const cardStyle = {
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        padding: '24px',
        marginBottom: '20px'
    };

    const uploadBtnStyle = {
        ...styles.button,
        background: 'linear-gradient(135deg, #10b981, #059669)',
        marginRight: '12px'
    };

    const templateBtnStyle = {
        ...styles.button,
        background: '#64748b'
    };

    return (
        <div>
            <h2 style={styles.sectionTitle}>📥 Veri Aktarımı</h2>
            <p style={{ color: '#64748b', marginBottom: '24px' }}>
                Başka bir ön muhasebe programından geçiş mi yapıyorsunuz? Verilerinizi Excel dosyaları ile kolayca aktarın.
            </p>

            {/* Müşteriler */}
            <div style={cardStyle}>
                <h3 style={{ margin: '0 0 12px 0', color: '#0f172a' }}>👥 Müşteri Aktarımı</h3>
                <p style={{ fontSize: '14px', color: '#64748b', marginBottom: '16px' }}>
                    Müşteri listesini Excel dosyası ile toplu olarak yükleyin.
                </p>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    <label style={uploadBtnStyle}>
                        {importing.customers ? 'Yükleniyor...' : '📤 Excel Yükle'}
                        <input type="file" accept=".xlsx,.xls" onChange={handleCustomerImport} style={{ display: 'none' }} disabled={importing.customers} />
                    </label>
                    <button onClick={downloadCustomerTemplate} style={templateBtnStyle}>📋 Şablon İndir</button>
                </div>
                {importResults.customers && (
                    <div style={{ marginTop: '12px', padding: '12px', background: importResults.customers.error > 0 ? '#fef2f2' : '#dcfce7', borderRadius: '8px', fontSize: '14px' }}>
                        ✅ {importResults.customers.success} başarılı{importResults.customers.error > 0 && `, ❌ ${importResults.customers.error} hatalı`}
                    </div>
                )}
            </div>

            {/* Tedarikçiler */}
            <div style={cardStyle}>
                <h3 style={{ margin: '0 0 12px 0', color: '#0f172a' }}>🏢 Tedarikçi Aktarımı</h3>
                <p style={{ fontSize: '14px', color: '#64748b', marginBottom: '16px' }}>
                    Tedarikçi listesini Excel dosyası ile toplu olarak yükleyin.
                </p>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    <label style={uploadBtnStyle}>
                        {importing.suppliers ? 'Yükleniyor...' : '📤 Excel Yükle'}
                        <input type="file" accept=".xlsx,.xls" onChange={handleSupplierImport} style={{ display: 'none' }} disabled={importing.suppliers} />
                    </label>
                    <button onClick={downloadSupplierTemplate} style={templateBtnStyle}>📋 Şablon İndir</button>
                </div>
                {importResults.suppliers && (
                    <div style={{ marginTop: '12px', padding: '12px', background: importResults.suppliers.error > 0 ? '#fef2f2' : '#dcfce7', borderRadius: '8px', fontSize: '14px' }}>
                        ✅ {importResults.suppliers.success} başarılı{importResults.suppliers.error > 0 && `, ❌ ${importResults.suppliers.error} hatalı`}
                    </div>
                )}
            </div>

            {/* Ürünler */}
            <div style={cardStyle}>
                <h3 style={{ margin: '0 0 12px 0', color: '#0f172a' }}>📦 Ürün Aktarımı</h3>
                <p style={{ fontSize: '14px', color: '#64748b', marginBottom: '16px' }}>
                    Ürün listesini Excel dosyası ile toplu olarak yükleyin. Grup adları mevcut gruplarla eşleşmelidir.
                </p>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    <label style={uploadBtnStyle}>
                        {importing.products ? 'Yükleniyor...' : '📤 Excel Yükle'}
                        <input type="file" accept=".xlsx,.xls" onChange={handleProductImport} style={{ display: 'none' }} disabled={importing.products} />
                    </label>
                    <button onClick={downloadProductTemplate} style={templateBtnStyle}>📋 Şablon İndir</button>
                </div>
                {importResults.products && (
                    <div style={{ marginTop: '12px', padding: '12px', background: importResults.products.error > 0 ? '#fef2f2' : '#dcfce7', borderRadius: '8px', fontSize: '14px' }}>
                        ✅ {importResults.products.success} başarılı{importResults.products.error > 0 && `, ❌ ${importResults.products.error} hatalı`}
                    </div>
                )}
            </div>

            {/* Siparişler */}
            <div style={cardStyle}>
                <h3 style={{ margin: '0 0 12px 0', color: '#0f172a' }}>📋 Sipariş Aktarımı</h3>
                <p style={{ fontSize: '14px', color: '#64748b', marginBottom: '16px' }}>
                    Geçmiş siparişlerinizi Excel dosyası ile toplu olarak yükleyin. Müşteri adları mevcut müşterilerle eşleştirilir.
                </p>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    <label style={uploadBtnStyle}>
                        {importing.orders ? 'Yükleniyor...' : '📤 Excel Yükle'}
                        <input type="file" accept=".xlsx,.xls" onChange={handleOrderImport} style={{ display: 'none' }} disabled={importing.orders} />
                    </label>
                    <button onClick={downloadOrderTemplate} style={templateBtnStyle}>📋 Şablon İndir</button>
                </div>
                {importResults.orders && (
                    <div style={{ marginTop: '12px', padding: '12px', background: importResults.orders.error > 0 ? '#fef2f2' : '#dcfce7', borderRadius: '8px', fontSize: '14px' }}>
                        ✅ {importResults.orders.success} başarılı{importResults.orders.error > 0 && `, ❌ ${importResults.orders.error} hatalı`}
                    </div>
                )}
            </div>

            <div style={{ marginTop: '24px', padding: '16px', background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: '8px' }}>
                <strong style={{ color: '#92400e' }}>⚠️ Önemli Notlar:</strong>
                <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px', color: '#92400e', fontSize: '14px' }}>
                    <li>Önce şablon dosyalarını indirip formatı inceleyin.</li>
                    <li>Verilerinizi şablon formatına uygun şekilde hazırlayın.</li>
                    <li>Ürün aktarımı için önce "Ürün Grupları" sekmesinden grupları oluşturun.</li>
                    <li>Aktarım işlemi geri alınamaz, dikkatli olun.</li>
                </ul>
            </div>
        </div>
    );
}

// --- MAĞAZA YÖNETİMİ ---
function StoreManagementSection({ userData, showMessage }) {
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showNewStoreForm, setShowNewStoreForm] = useState(false);
    const [isCreating, setIsCreating] = useState(false);
    const [editingStore, setEditingStore] = useState(null);
    
    const [newStore, setNewStore] = useState({
        name: '',
        email: '',
        password: '',
        phone: '',
        address: '',
        canViewMainStock: false
    });

    useEffect(() => {
        if (!userData?.companyId) return;
        const storesRef = collection(db, 'companies', userData.companyId, 'stores');
        const q = query(storesRef, orderBy('createdAt', 'desc'));
        
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setStores(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setLoading(false);
        });
        
        return () => unsubscribe();
    }, [userData?.companyId]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setNewStore(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleCreateStore = async (e) => {
        e.preventDefault();
        
        if (!newStore.name || !newStore.email || !newStore.password) {
            showMessage('Lütfen zorunlu alanları doldurun (Mağaza Adı, E-posta, Şifre).', 'error');
            return;
        }
        
        if (newStore.password.length < 6) {
            showMessage('Şifre en az 6 karakter olmalıdır.', 'error');
            return;
        }

        setIsCreating(true);

        try {
            const secondaryApp = initializeApp(firebaseConfig, `StoreCreator_${Date.now()}`);
            const secondaryAuth = getAuth(secondaryApp);
            
            const userCredential = await createUserWithEmailAndPassword(secondaryAuth, newStore.email, newStore.password);
            const storeId = userCredential.user.uid;
            
            await secondaryAuth.signOut();

            const adminUid = getAuth().currentUser?.uid || userData?.uid || userData?.id || 'admin_user';

            await setDoc(doc(db, 'users', storeId), {
                email: newStore.email,
                role: 'store',
                companyId: userData.companyId,
                storeName: newStore.name,
                createdAt: new Date(),
                createdBy: adminUid
            });

            await setDoc(doc(db, 'companies', userData.companyId, 'stores', storeId), {
                name: newStore.name,
                email: newStore.email,
                phone: newStore.phone,
                address: newStore.address,
                permissions: {
                    canViewMainStock: newStore.canViewMainStock
                },
                status: 'active',
                createdAt: new Date(),
                createdBy: adminUid
            });

            showMessage('Mağaza başarıyla oluşturuldu!', 'success');
            setShowNewStoreForm(false);
            setNewStore({
                name: '', email: '', password: '', phone: '', address: '', canViewMainStock: false
            });
        } catch (error) {
            console.error('Store creation error:', error);
            if (error.code === 'auth/email-already-in-use') {
                showMessage('Bu e-posta adresi zaten kullanımda! Lütfen farklı bir e-posta kullanın.', 'error');
            } else {
                showMessage('Mağaza oluşturulurken hata: ' + error.message, 'error');
            }
        } finally {
            setIsCreating(false);
        }
    };

    const handleToggleStatus = async (storeId, currentStatus) => {
        try {
            await updateDoc(doc(db, 'companies', userData.companyId, 'stores', storeId), {
                status: currentStatus === 'active' ? 'inactive' : 'active'
            });
            showMessage('Mağaza durumu güncellendi.');
        } catch (error) {
            showMessage('Durum güncellenemedi: ' + error.message, 'error');
        }
    };

    const handleSaveEdit = async () => {
        if (!editingStore) return;
        try {
            await updateDoc(doc(db, 'companies', userData.companyId, 'stores', editingStore.id), {
                name: editingStore.name,
                phone: editingStore.phone || '',
                address: editingStore.address || '',
                permissions: {
                    canViewMainStock: editingStore.permissions?.canViewMainStock || false
                }
            });
            // Also update the users document storeName
            await updateDoc(doc(db, 'users', editingStore.id), {
                storeName: editingStore.name
            });
            showMessage('Mağaza bilgileri güncellendi!', 'success');
            setEditingStore(null);
        } catch (error) {
            showMessage('Güncelleme hatası: ' + error.message, 'error');
        }
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <div>
                    <h2 style={styles.sectionTitle}>🏬 Mağaza (Franchise) Yönetimi</h2>
                    <p style={{ color: '#64748b' }}>Firmanıza bağlı perakende satış yapacak şubeleri/mağazaları yönetin.</p>
                </div>
                {!showNewStoreForm && (
                    <button 
                        onClick={() => setShowNewStoreForm(true)}
                        style={{ ...styles.button, background: '#10b981' }}
                    >
                        + Yeni Mağaza Ekle
                    </button>
                )}
            </div>

            {showNewStoreForm && (
                <div style={{ background: '#f8fafc', padding: '24px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '24px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
                        <h3 style={{ margin: 0 }}>Yeni Mağaza Oluştur</h3>
                        <button onClick={() => setShowNewStoreForm(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px' }}>&times;</button>
                    </div>
                    
                    <form onSubmit={handleCreateStore}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Mağaza Adı*</label>
                                <input style={styles.input} type="text" name="name" value={newStore.name} onChange={handleInputChange} required />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Mağaza Giriş E-postası*</label>
                                <input style={styles.input} type="email" name="email" value={newStore.email} onChange={handleInputChange} required />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Giriş Şifresi*</label>
                                <input style={styles.input} type="password" name="password" value={newStore.password} onChange={handleInputChange} required minLength="6" />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Telefon</label>
                                <input style={styles.input} type="tel" name="phone" value={newStore.phone} onChange={handleInputChange} />
                            </div>
                        </div>
                        
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Adres</label>
                            <input style={styles.input} type="text" name="address" value={newStore.address} onChange={handleInputChange} />
                        </div>
                        
                        <div style={{ marginBottom: '20px', padding: '12px', background: 'white', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                <input type="checkbox" name="canViewMainStock" checked={newStore.canViewMainStock} onChange={handleInputChange} />
                                <span style={{ fontWeight: '500' }}>Bu mağaza, ana firmanın stok durumunu (salt okunur) görebilsin</span>
                            </label>
                        </div>

                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                            <button type="button" onClick={() => setShowNewStoreForm(false)} style={{ ...styles.button, background: '#64748b' }}>İptal</button>
                            <button type="submit" style={{ ...styles.button }} disabled={isCreating}>
                                {isCreating ? 'Oluşturuluyor...' : 'Mağazayı Kaydet'}
                            </button>
                        </div>
                    </form>
                </div>
            )}

            <div style={styles.listContainer}>
                {loading ? <p>Yükleniyor...</p> : stores.length > 0 ? (
                    <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                        <thead style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                            <tr>
                                <th style={{ padding: '12px 16px', textAlign: 'left', color: '#64748b', fontWeight: '600', fontSize: '13px' }}>Mağaza Adı</th>
                                <th style={{ padding: '12px 16px', textAlign: 'left', color: '#64748b', fontWeight: '600', fontSize: '13px' }}>E-posta</th>
                                <th style={{ padding: '12px 16px', textAlign: 'left', color: '#64748b', fontWeight: '600', fontSize: '13px' }}>Stok İzni</th>
                                <th style={{ padding: '12px 16px', textAlign: 'left', color: '#64748b', fontWeight: '600', fontSize: '13px' }}>Durum</th>
                                <th style={{ padding: '12px 16px', textAlign: 'right', color: '#64748b', fontWeight: '600', fontSize: '13px' }}>İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            {stores.map(store => (
                                <tr key={store.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                    <td style={{ padding: '16px', fontWeight: '500' }}>{store.name}</td>
                                    <td style={{ padding: '16px', color: '#64748b' }}>{store.email}</td>
                                    <td style={{ padding: '16px' }}>
                                        {store.permissions?.canViewMainStock ? 
                                            <span style={{ background: '#dcfce7', color: '#166534', padding: '4px 8px', borderRadius: '4px', fontSize: '12px' }}>Görüntüleyebilir</span> : 
                                            <span style={{ background: '#f1f5f9', color: '#64748b', padding: '4px 8px', borderRadius: '4px', fontSize: '12px' }}>Yetki Yok</span>
                                        }
                                    </td>
                                    <td style={{ padding: '16px' }}>
                                        <span style={{ 
                                            background: store.status === 'active' ? '#dcfce7' : '#fef2f2', 
                                            color: store.status === 'active' ? '#166534' : '#991b1b',
                                            padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '500' 
                                        }}>
                                            {store.status === 'active' ? 'Aktif' : 'Pasif'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '16px', textAlign: 'right' }}>
                                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                                            <button 
                                                onClick={() => setEditingStore({ ...store })}
                                                style={{ 
                                                    background: 'none', border: '1px solid #e2e8f0', 
                                                    padding: '4px 10px', borderRadius: '6px', cursor: 'pointer',
                                                    fontSize: '13px', color: '#06C167'
                                                }}
                                            >
                                                Düzenle
                                            </button>
                                            <button 
                                                onClick={() => handleToggleStatus(store.id, store.status)}
                                                style={{ 
                                                    background: 'none', border: '1px solid #e2e8f0', 
                                                    padding: '4px 10px', borderRadius: '6px', cursor: 'pointer',
                                                    fontSize: '13px', color: store.status === 'active' ? '#ef4444' : '#10b981'
                                                }}
                                            >
                                                {store.status === 'active' ? 'Pasif Yap' : 'Aktif Yap'}
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div style={{ textAlign: 'center', padding: '40px', background: '#f8fafc', borderRadius: '8px', border: '1px dashed #cbd5e1' }}>
                        <p style={{ color: '#64748b' }}>Henüz hiç mağaza oluşturulmamış.</p>
                        <p style={{ fontSize: '14px', color: '#94a3b8', marginTop: '8px' }}>Yeni bir mağaza ekleyerek bayilerinize perakende satış paneli açabilirsiniz.</p>
                    </div>
                )}
            </div>

            {/* Edit Store Modal */}
            {editingStore && (
                <div style={styles.modalOverlay} onClick={() => setEditingStore(null)}>
                    <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3>Mağaza Düzenle: {editingStore.email}</h3>
                            <button onClick={() => setEditingStore(null)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>&times;</button>
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Mağaza Adı</label>
                            <input 
                                style={styles.input} 
                                type="text" 
                                value={editingStore.name} 
                                onChange={(e) => setEditingStore(prev => ({ ...prev, name: e.target.value }))} 
                            />
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Telefon</label>
                            <input 
                                style={styles.input} 
                                type="tel" 
                                value={editingStore.phone || ''} 
                                onChange={(e) => setEditingStore(prev => ({ ...prev, phone: e.target.value }))} 
                            />
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Adres</label>
                            <input 
                                style={styles.input} 
                                type="text" 
                                value={editingStore.address || ''} 
                                onChange={(e) => setEditingStore(prev => ({ ...prev, address: e.target.value }))} 
                            />
                        </div>
                        <div style={{ marginBottom: '20px', padding: '12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                <input 
                                    type="checkbox" 
                                    checked={editingStore.permissions?.canViewMainStock || false} 
                                    onChange={(e) => setEditingStore(prev => ({ 
                                        ...prev, 
                                        permissions: { ...prev.permissions, canViewMainStock: e.target.checked } 
                                    }))} 
                                />
                                <span style={{ fontWeight: '500' }}>Ana firmanın stok durumunu (salt okunur) görebilsin</span>
                            </label>
                        </div>
                        <div style={styles.modalActions}>
                            <button onClick={() => setEditingStore(null)} style={{ ...styles.button, background: '#6c757d' }}>İptal</button>
                            <button onClick={handleSaveEdit} style={{ ...styles.button, background: '#28a745' }}>Kaydet</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

// --- E-FATURA AYARLARI ---
function EInvoiceSettingsSection({ userData, showMessage }) {
    const [settings, setSettings] = useState({
        sovosUsername: '',
        sovosPassword: '',
        companyShortCode: '', // Firma Kısa Kod
        vkn: '',
        isTestMode: true,
        senderIdentifier: '', // PK (Posta Kutusu) - SOVOS'tan alınır
        senderAlias: '',      // GB (Gönderici Birim) - SOVOS'tan alınır
        companyTitle: '',     // Firma Ünvanı (E-Fatura'da görünecek)
        companyCity: '',
        companyDistrict: '',
        companyAddress: '',
        companyPhone: '',
        companyEmail: '',
        taxOffice: '',
        defaultInvoicePrefix: 'RAC',
    });
    const [loading, setLoading] = useState(true);
    const [testing, setTesting] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (!userData?.companyId) return;
        const fetchSettings = async () => {
            try {
                const docRef = doc(db, 'companies', userData.companyId);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists() && docSnap.data().eInvoiceSettings) {
                    setSettings(prev => ({ ...prev, ...docSnap.data().eInvoiceSettings }));
                }
                // Also pull company info defaults
                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setSettings(prev => ({
                        ...prev,
                        companyTitle: prev.companyTitle || data.companyName || '',
                        taxOffice: prev.taxOffice || data.taxOffice || '',
                        vkn: prev.vkn || data.taxNumber || '',
                        companyAddress: prev.companyAddress || data.address || '',
                        companyPhone: prev.companyPhone || data.phone || '',
                    }));
                }
            } catch (err) {
                console.error('E-Fatura ayarları yüklenirken hata:', err);
            }
            setLoading(false);
        };
        fetchSettings();
    }, [userData]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setSettings(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!userData?.companyId) return;
        try {
            const docRef = doc(db, 'companies', userData.companyId);
            await setDoc(docRef, { eInvoiceSettings: settings }, { merge: true });
            showMessage('E-Fatura ayarları başarıyla kaydedildi!');
        } catch (err) {
            showMessage('Ayarlar kaydedilirken hata oluştu: ' + err.message, 'error');
        }
    };

    const handleTestConnection = async () => {
        if (!settings.sovosUsername || !settings.sovosPassword) {
            showMessage('Lütfen önce SOVOS kullanıcı adı ve şifresini girin.', 'error');
            return;
        }
        setTesting(true);
        try {
            const testFn = httpsCallable(functions, 'testSovosConnection');
            const result = await testFn({
                username: settings.sovosUsername,
                password: settings.sovosPassword,
                isTestMode: settings.isTestMode,
                vkn: settings.vkn
            });
            if (result.data.success) {
                showMessage('✅ SOVOS bağlantısı başarılı! API erişimi doğrulandı.');
            } else {
                showMessage('❌ Bağlantı başarısız: ' + (result.data.error || 'Bilinmeyen hata'), 'error');
            }
        } catch (err) {
            showMessage('❌ Bağlantı testi başarısız: ' + err.message, 'error');
        }
        setTesting(false);
    };

    if (loading) return <div>Yükleniyor...</div>;

    const sectionStyle = {
        marginBottom: '32px',
        padding: '24px',
        background: '#f8fafc',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
    };
    const sectionTitleStyle = {
        fontSize: '16px',
        fontWeight: '700',
        color: '#0f172a',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    };
    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '16px'
    };

    return (
        <div style={{ maxWidth: '800px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
                <span style={{ fontSize: '32px' }}>🧾</span>
                <div>
                    <h2 style={{ ...styles.sectionTitle, marginBottom: '4px' }}>E-Fatura / E-Arşiv Ayarları</h2>
                    <p style={{ margin: 0, fontSize: '14px', color: '#64748b' }}>SOVOS entegratörü üzerinden e-Fatura ve e-Arşiv kesimi için gerekli ayarlar</p>
                </div>
            </div>

            {/* Ortam Bilgisi */}
            <div style={{
                padding: '12px 16px',
                borderRadius: '8px',
                marginBottom: '24px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                background: settings.isTestMode ? '#fffbeb' : '#ecfdf5',
                border: `1px solid ${settings.isTestMode ? '#fcd34d' : '#6ee7b7'}`
            }}>
                <span style={{ fontSize: '20px' }}>{settings.isTestMode ? '🧪' : '🟢'}</span>
                <div>
                    <div style={{ fontWeight: '600', fontSize: '14px', color: settings.isTestMode ? '#92400e' : '#065f46' }}>
                        {settings.isTestMode ? 'TEST ORTAMI' : 'CANLI ORTAM (PRODUCTION)'}
                    </div>
                    <div style={{ fontSize: '12px', color: settings.isTestMode ? '#a16207' : '#047857' }}>
                        {settings.isTestMode ? 'Faturalar GİB test portalına gönderilir, gerçek fatura kesilmez.' : '⚠️ DİKKAT: Faturalar GİB\'e resmi olarak gönderilecektir!'}
                    </div>
                </div>
            </div>

            <form onSubmit={handleSave}>
                {/* SOVOS API Bağlantı Bilgileri */}
                <div style={sectionStyle}>
                    <div style={sectionTitleStyle}>
                        <span>🔐</span> SOVOS API Bağlantı Bilgileri
                    </div>
                    <div style={gridStyle}>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Firma Kısa Kod</label>
                            <input style={styles.input} type="text" name="companyShortCode" value={settings.companyShortCode} onChange={handleChange} placeholder="Örn: FIRMA" />
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Kullanıcı Kodu (WS)</label>
                            <input style={styles.input} type="text" name="sovosUsername" value={settings.sovosUsername} onChange={handleChange} placeholder="Kullanıcı Kodu" />
                            <small style={{ color: '#64748b', fontSize: '11px', display: 'block', marginTop: '4px' }}>Web Servis Kullanıcı Kodu</small>
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Şifre (WS)</label>
                            <div style={{ position: 'relative' }}>
                                <input style={{ ...styles.input, paddingRight: '40px' }} type={showPassword ? 'text' : 'password'} name="sovosPassword" value={settings.sovosPassword} onChange={handleChange} placeholder="Şifre" />
                                <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px' }}>
                                    {showPassword ? '🙈' : '👁️'}
                                </button>
                            </div>
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Vergi Kimlik Numarası (VKN)</label>
                            <input style={styles.input} type="text" name="vkn" value={settings.vkn} onChange={handleChange} placeholder="1234567890" maxLength={11} />
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Ortam</label>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px', background: 'white', borderRadius: '8px', border: '1px solid #e2e8f0', cursor: 'pointer' }}>
                                <input type="checkbox" name="isTestMode" checked={settings.isTestMode} onChange={handleChange} />
                                <span style={{ fontWeight: '500', fontSize: '14px' }}>Test Ortamı</span>
                            </label>
                        </div>
                    </div>
                    <div style={{ marginTop: '16px' }}>
                        <button type="button" onClick={handleTestConnection} disabled={testing} style={{
                            ...styles.button,
                            background: testing ? '#94a3b8' : 'linear-gradient(135deg, #0ea5e9, #0284c7)',
                            cursor: testing ? 'not-allowed' : 'pointer'
                        }}>
                            {testing ? '⏳ Test Ediliyor...' : '🔌 Bağlantıyı Test Et'}
                        </button>
                    </div>
                </div>

                {/* SOVOS Tanımlayıcı Bilgileri */}
                <div style={sectionStyle}>
                    <div style={sectionTitleStyle}>
                        <span>📮</span> SOVOS Tanımlayıcı Bilgileri
                    </div>
                    <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '16px' }}>
                        Bu bilgileri SOVOS hesabınızdan (FitBulut panelinden) temin edebilirsiniz.
                    </p>
                    <div style={gridStyle}>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Posta Kutusu (PK) Etiketi</label>
                            <input style={styles.input} type="text" name="senderIdentifier" value={settings.senderIdentifier} onChange={handleChange} placeholder="urn:mail:defaultpk@..." />
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Gönderici Birim (GB) Etiketi</label>
                            <input style={styles.input} type="text" name="senderAlias" value={settings.senderAlias} onChange={handleChange} placeholder="urn:mail:defaultgb@..." />
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Fatura Ön Eki</label>
                            <input style={styles.input} type="text" name="defaultInvoicePrefix" value={settings.defaultInvoicePrefix} onChange={handleChange} placeholder="RAC" maxLength={3} />
                            <small style={{ color: '#64748b', fontSize: '12px' }}>Fatura numarası örneği: {settings.defaultInvoicePrefix}2026000000001</small>
                        </div>
                    </div>
                </div>

                {/* Firma Bilgileri (E-Faturada görünecek) */}
                <div style={sectionStyle}>
                    <div style={sectionTitleStyle}>
                        <span>🏢</span> Firma Bilgileri (E-Faturada Görünecek)
                    </div>
                    <div style={gridStyle}>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Firma Ünvan</label>
                            <input style={styles.input} type="text" name="companyTitle" value={settings.companyTitle} onChange={handleChange} />
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Vergi Dairesi</label>
                            <input style={styles.input} type="text" name="taxOffice" value={settings.taxOffice} onChange={handleChange} />
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>İl</label>
                            <input style={styles.input} type="text" name="companyCity" value={settings.companyCity} onChange={handleChange} />
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>İlçe</label>
                            <input style={styles.input} type="text" name="companyDistrict" value={settings.companyDistrict} onChange={handleChange} />
                        </div>
                        <div style={{ ...styles.formGroup, gridColumn: '1 / -1' }}>
                            <label style={styles.label}>Adres</label>
                            <input style={styles.input} type="text" name="companyAddress" value={settings.companyAddress} onChange={handleChange} />
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Telefon</label>
                            <input style={styles.input} type="text" name="companyPhone" value={settings.companyPhone} onChange={handleChange} />
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>E-Posta</label>
                            <input style={styles.input} type="email" name="companyEmail" value={settings.companyEmail} onChange={handleChange} />
                        </div>
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                    <button type="submit" style={styles.button}>💾 Ayarları Kaydet</button>
                </div>
            </form>
        </div>
    );
}

// Ana Ayarlar Bileşeni
function Settings() {
    const { userData } = useAuth();
    const { canViewSensitiveData } = useOutletContext();
    const [activeTab, setActiveTab] = useState('company');
    const [message, setMessage] = useState({ text: '', type: 'success' });

    const showMessage = (text, type = 'success') => {
        setMessage({ text, type });
        setTimeout(() => setMessage({ text: '', type: 'success' }), 4000);
    };

    const messageStyle = message.type === 'success'
        ? { ...styles.message, ...styles.successMessage }
        : { ...styles.message, ...styles.errorMessage };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <div style={styles.headerLeft}>
                    <h1 style={styles.title}>Ayarlar</h1>
                    <p style={styles.subtitle}>Sistem ayarlarınızı yönetin ve konfigüre edin</p>
                </div>
            </div>

            <div style={styles.tabs}>
                <button style={{ ...styles.tab, ...(activeTab === 'company' && styles.activeTab) }} onClick={() => setActiveTab('company')}>Firma Bilgileri</button>
                <button style={{ ...styles.tab, ...(activeTab === 'personnel' && styles.activeTab) }} onClick={() => setActiveTab('personnel')}>Personel Yönetimi</button>
                {userData?.role === 'admin' && <button style={{ ...styles.tab, ...(activeTab === 'stores' && styles.activeTab) }} onClick={() => setActiveTab('stores')}>Mağazalar</button>}
                <button style={{ ...styles.tab, ...(activeTab === 'productGroups' && styles.activeTab) }} onClick={() => setActiveTab('productGroups')}>Ürün Grupları</button>
                <button style={{ ...styles.tab, ...(activeTab === 'apiSettings' && styles.activeTab) }} onClick={() => setActiveTab('apiSettings')}>API Anahtarları</button>
                <button style={{ ...styles.tab, ...(activeTab === 'dataMigration' && styles.activeTab) }} onClick={() => setActiveTab('dataMigration')}>Veri Aktarımı</button>
                <button style={{ ...styles.tab, ...(activeTab === 'pdfSettings' && styles.activeTab) }} onClick={() => setActiveTab('pdfSettings')}>PDF Ayarları</button>
                <button style={{ ...styles.tab, ...(activeTab === 'currency' && styles.activeTab) }} onClick={() => setActiveTab('currency')}>Kur Ayarları</button>
                <button style={{ ...styles.tab, ...(activeTab === 'cargoIntegration' && styles.activeTab) }} onClick={() => setActiveTab('cargoIntegration')}>Kargo Entegrasyon</button>
                <button style={{ ...styles.tab, ...(activeTab === 'eInvoice' && styles.activeTab) }} onClick={() => setActiveTab('eInvoice')}>🧾 E-Fatura</button>
                <button style={{ ...styles.tab, ...(activeTab === 'backup' && styles.activeTab) }} onClick={() => setActiveTab('backup')}>Yedekleme</button>
                <button style={{ ...styles.tab, ...(activeTab === 'activityTracking' && styles.activeTab) }} onClick={() => setActiveTab('activityTracking')}>Aktivite İzleme</button>
                <button style={{ ...styles.tab, ...(activeTab === 'systemCheck' && styles.activeTab) }} onClick={() => setActiveTab('systemCheck')}>Sistem Kontrolü</button>
            </div>

            <div style={styles.content}>
                {activeTab === 'company' && <CompanyInfoSection userData={userData} showMessage={showMessage} />}
                {activeTab === 'personnel' && <PersonnelManagementSection userData={userData} showMessage={showMessage} />}
                {activeTab === 'stores' && <StoreManagementSection userData={userData} showMessage={showMessage} />}
                {activeTab === 'productGroups' && <ProductGroupsSection userData={userData} showMessage={showMessage} canViewSensitiveData={canViewSensitiveData} />}
                {activeTab === 'apiSettings' && <APISettingsSection userData={userData} showMessage={showMessage} />}
                {activeTab === 'dataMigration' && <DataMigrationSection userData={userData} showMessage={showMessage} />}
                {activeTab === 'pdfSettings' && <PdfSettingsSection userData={userData} showMessage={showMessage} />}
                {activeTab === 'currency' && <CurrencySettingsSection userData={userData} showMessage={showMessage} />}
                {activeTab === 'cargoIntegration' && <CargoIntegrationSettings />}
                {activeTab === 'eInvoice' && <EInvoiceSettingsSection userData={userData} showMessage={showMessage} />}
                {activeTab === 'backup' && <BackupSection userData={userData} showMessage={showMessage} />}
                {activeTab === 'activityTracking' && <ActivityTrackingSection userData={userData} showMessage={showMessage} />}
                {activeTab === 'systemCheck' && <SystemCheckSection userData={userData} showMessage={showMessage} />}
            </div>

            {message.text && (<div style={messageStyle}>{message.text}</div>)}
        </div>
    );
}

export default Settings;
